import React, { useState, useEffect } from "react";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import { useDispatch, useSelector } from "react-redux";
import { selectRelatedToType, selectAssignType, selectTaskCategoryOptions, selectTaskStatusOptions, selectTaskPriorityOptions, ratingOptions } from "../../../core/common/selectoption/selectoption";
import {
  setActivityTogglePopup,
  setActivityTogglePopupTwo,
} from "../../../core/data/redux/commonSlice";
import { createLogCall, deleteLogCall, viewMemberLogCall, updateLogCall, userList, detailLogCall, updateLogCallStatus, listLeadsOption, listContactsOptionn, listAccountsOption, listOpportunitiesOption } from "./logcall_api";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import Select, { MultiValue } from "react-select";
import {
  accountType,
  ascendingandDecending,
  companyName,
  documentType,
  duration,
  languageOptions,
  LocaleData,
  optionssymbol,
  priorityList,
  project,
  salestypelist,
  socialMedia,
  status,
  statusList,
  tagInputValues,
} from "../../../core/common/selectoption/selectoption";
import { createEvent, ViewMemberEvent, deleteEvent, getEventDetail, updateEvent } from "./event_api";
import DatePicker from "react-datepicker";
import DefaultEditor from "react-simple-wysiwyg";
import { TagsInput } from "react-tag-input-component";
import CollapseHeader from "../../../core/common/collapse-header";
import { SelectWithImage } from "../../../core/common/selectWithImage";
import { SelectWithImage2 } from "../../../core/common/selectWithImage2";
import {
  getContactDetail,
  createContactTask,
  viewContactTasks,
  updateContactTask,
  deleteContactTask,
  createContactLogCall,
  viewContactLogCalls,
  updateContactLogCall,
  deleteContactLogCall,
  getContactLogCallDetail,
  updateContactLogCallStatus
} from "./contactAPI";
import { createTask, deleteTask, viewMemberTasks, updateTask, detailTask } from "./task_api";
import { useParams } from 'react-router-dom';
import Cloning from "../../uiInterface/base-ui/ui-sortable/cloning";
import { sendEmail, listAllEmail } from "./email_api";
import ResponseModal from "../../../core/modals/response_modal";
import ActivityList from "../activity";
import { ACTIVITY_TYPES } from "../activity/activityAPI";
interface ContactDetail {
  contactId: number;
  accountId: number;
  accountName: string;
  salutation: string;
  title: string;
  contactOwnerUuid: string;
  contactOwnerName: string | null;
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  mobileNumber: string;
  reportTo: number | null;
  reportToName: string | null;
  fax: string;
  department: string;
  mailingStreet: string | null;
  mailingCity: string | null;
  mailingState: string | null;
  mailingZip: string | null;
  mailingCountry: string | null;
  description: string | null;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
  rating: string | null;
  facebook: string | null,
  skype: string | null,
  linkedin: string | null,
  twitter: string | null,
  instagram: string | null,
  whatsapp: string | null,
  campaignHistory: {
    campaignId: number;
    campaignName: string;
    startDate: string;
    endDate: string;
    type: string;
    status: string;
  }[];
  opportunityContacts: {
    opportunityId: number;
    opportunityName: string;
    stage: string;
    amount: number;
    accountId: number;
    accountName: string;
    owner: string;
  }[];
  tagList: {
    tagId: number;
    name: string;
  }[];
}
interface EventDetailDTO {
  subject: string;
  description: string;
  attendees: { id: number; name: string }[];
  location: string;
  targetType: string;
  targets: { id: number; name: string };
  assignType: string;
  assignee: { id: number; name: string }[];
  startTime: string;
  endTime: string;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
}
interface Tasks {
  id: number;
  uuid: string;
  title: string;
  category: string;
  responsible: { uuid: string; username: string };
  startDate: string;
  endDate: string;
  targetType: string;
  assignType: string;
  priority: string;
  status: string;
  description?: string
}
interface TaskDetailDTO {
  title: string;
  category: string;
  responsible: { uuid: string; username: string }
  startDate: string;
  endDate: string;
  assignTags: Array<{ id: number; uuid: string; name: string }>;
  priority: string;
  status: string;
  description: string;
  targetType: string;
  targets: { id: number; name: string };
  assignType: string;
  assignee: { id: number; name: string };
}
interface Event {
  id: number;
  uuid: string;
  subject: string;
  description: string;
  startTime: string;
  endTime: string;
}
interface LogCallDataCreate {
  userCall?: string;
  status: string;
  followUpDate: string;
  note: string;
  assignType: string;
  assignRecord: number;
  targetType: string;
  targetRecord: number;
  checkedCreateFollowingTask: boolean;
}
interface LogCallDataUpdate {
  userCall?: string;
  status: string;
  followUpDate: string;
  note: string;
  assignType?: string;
  assignRecord?: number;
  targetType?: string;
  targetRecord?: number;
}
interface LogCallDataDetail {
  id: number;
  uuid?: string;
  status: string;
  userCall: { uuid: string; username: string };
  callTime: string;
  notes: string;
  followUpTime: string;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
  targetType: string;
  targets: { id: number; name: string };
  assignType: string;
  assignee: { id: number; name: string };
}
interface AccountListDTO {
  accountId: number;
  accountName: string;
}
interface CreateTaskDTO {
  memberId: number;
  title: string;
  category: string;
  responsible: string;
  startDate: string;
  endDate?: string;
  status: string;
  priority: string;
  description?: string;
  assignType: string;
  assignId: number;
  targetType: string;
  targetId: number;
}
interface UpdateTaskDTO {
  memberId: number;
  title: string;
  category: string;
  responsible: string;
  startDate: string;
  endDate?: string;
  status: string;
  priority: string;
  description?: string;
  assignType: string;
  assignId: number;
  targetType: string;
  targetId: number;
}
interface LeadListDTO {
  leadId: number;
  leadUuid: string;
  leadName: string;
  company: string;
  phone: string;
  email: string;
  leadStageId: number;
  leadStatus: string;
  createdDate: string;
  leadOwner: string;
}
interface ContactlListDTO {
  contactId: number;
  contactName: string;
}
interface OpportunityListDTO {
  id: number;
  name: string;
}
interface UserCall {
  id: number;
  uuid: string;
  username: string;
  role: string;
}
interface CreateEventDTO {
  subject: string;
  description: string;
  attendees: number[];
  location: string;
  targetType: string;
  targetIds: number | null;
  assignType: string;
  assigneeId: number[];
  startTime: string;
  endTime: string;
}
interface UpdateEventDTO {
  subject: string;
  description: string;
  attendees: number[];
  location: string;
  targetType: string;
  targetIds: number | null;
  assignType: string;
  assigneeId: number[];
  startTime: string;
  endTime: string;
}
interface EventDetailDTO {
  subject: string;
  description: string;
  attendees: { id: number; name: string }[];
  location: string;
  targetType: string;
  targets: { id: number; name: string };
  assignType: string;
  assignee: { id: number; name: string }[];
  startTime: string;
  endTime: string;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
}
interface EmailContactResponse {
  subject: string;
  body: string;
  createdAt: string;
  createdBy: string;
  childEmailLogs: {
    subject: string;
    body: string;
  }[];
}
const getValidUrl = (url?: string | null): string => {
  if (!url) return "#";
  return url.startsWith("http://") || url.startsWith("https://")
    ? url
    : `https://${url}`;
};

const formatDateForInput = (dateString: string) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};
const ContactDetails = () => {
  const [contactDetail, setContactDetail] = useState<ContactDetail | null>(null);

  const [response, setResponse] = useState<{ status: "success" | "error"; message: string } | null>(null);
  const route = all_routes;
  const dispatch = useDispatch();
  const { id } = useParams();
  const activityToggle = useSelector(
    (state: any) => state?.activityTogglePopup
  );
  const [reloadActivity, setReloadActivity] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const activityToggleTwo = useSelector(
    (state: any) => state?.activityTogglePopupTwo
  );
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showMessageModal, setShowMessageModal] = useState(false);
  // Task states
  const [tasks, setTasks] = useState<Tasks[]>([]);
  const [taskTitle, setTaskTitle] = useState<string>("");
  const [taskCategory, setTaskCategory] = useState<string>("");
  const [taskResponsible, setTaskResponsible] = useState<string>("");
  const [taskStartDate, setTaskStartDate] = useState<string>("");
  const [taskEndDate, setTaskEndDate] = useState<string>("");
  const [taskStatus, setTaskStatus] = useState<string>("");
  const [taskPriority, setTaskPriority] = useState<string>("");
  const [taskDescription, setTaskDescription] = useState<string>("");
  const [showTaskModal, setShowTaskModal] = useState<boolean>(false);
  const [editingTask, setEditingTask] = useState<TaskDetailDTO | null>(null);
  const [taskToDelete, setTaskToDelete] = useState<{ id: number } | null>(null);
  const [showDeleteTaskModal, setShowDeleteTaskModal] = useState<boolean>(false);
  const [selectedTaskId, setSelectedTaskId] = useState<{ id: number } | null>(null);
  const [assignTaskOptions, setAssignTaskOptions] = useState<{ value: number; label: string }[]>([]);
  const [relateTaskOptions, setRelateTaskOptions] = useState<{ value: number; label: string }[]>([]);
  const [listUserCall, setListUserCall] = useState<UserCall[]>([]);
  // Call states
  const [logCalls, setLogCalls] = useState<any[]>([]);
  const [logCallStatus, setLogCallStatus] = useState<string>("");
  const [logCallFollowUpDate, setLogCallFollowUpDate] = useState<string>("");
  const [logCallNote, setLogCallNote] = useState<string>("");
  const [logCallUserCall, setLogCallUserCall] = useState<string>("");
  const [showCallModal, setShowCallModal] = useState<boolean>(false);
  const [showEditCallModal, setShowEditCallModal] = useState<boolean>(false);
  const [editingLogCall, setEditingLogCall] = useState<any>(null);
  const [logCallToDelete, setLogCallToDelete] = useState<{ id: number } | null>(null);
  const [showDeleteCallModal, setShowDeleteCallModal] = useState<boolean>(false);
  const [createLogCallFollowingTask, setLogCallCreateFollowingTask] = useState<boolean>(false);
  const [listLeadAssignType, setListLeadAssignType] = useState<LeadListDTO[]>([]);
  const [listContactAssignType, setListContactAssignType] = useState<ContactlListDTO[]>([]);
  const [listAccountRelatedToType, setListAccountRelatedToType] = useState<AccountListDTO[]>([]);
  const [listOpportunitiesRelatedToType, setListOpportunitiesRelatedToType] = useState<OpportunityListDTO[]>([]);
  //Events
  const [events, setEvents] = useState<Event[]>([]);
  const [selectedEventId, setSelectedEventId] = useState<number | null>(null);
  const [eventDetail, setEventDetail] = useState<EventDetailDTO | null>(null);
  const [attendees, setAttendees] = useState<{ value: number; label: string }[]>([]);
  //Email

  //Log Call
  const [showDeleteLogCallModal, setShowDeleteLogCallModal] = useState(false);
  const [selectedLogCallId, setSelectedLogCallId] = useState<{ id: number } | null>(null);
  const [showEditLogCallModal, setShowEditLogCallModal] = useState(false);
  const [newLogCall, setNewLogCall] = useState<LogCallDataCreate>({
    userCall: "",
    status: "",
    followUpDate: "",
    note: "",
    assignType: "",
    assignRecord: 0,
    targetType: "",
    targetRecord: 0,
    checkedCreateFollowingTask: false,
  });

  const [logCallDetail, setLogCallDetail] = useState<any>(null);
  const [editLogCall, setEditLogCall] = useState<LogCallDataUpdate>({
    userCall: "",
    status: "",
    followUpDate: "",
    note: "",
    assignType: "",
    assignRecord: 0,
    targetType: "",
    targetRecord: 0,
  });
  const getNewLogCallData = (): LogCallDataCreate => {
    return {
      userCall: newLogCall.userCall,
      status: newLogCall.status,
      followUpDate: newLogCall.followUpDate
        ? new Date(
          new Date(newLogCall.followUpDate).getTime()
        ).toISOString()
        : new Date().toISOString(),
      note: newLogCall.note,
      assignType: newLogCall.assignType,
      assignRecord: newLogCall.assignRecord,
      targetType: newLogCall.targetType,
      targetRecord: newLogCall.targetRecord,
      checkedCreateFollowingTask: newLogCall.checkedCreateFollowingTask,
    };
  };
  const handleDeleteClickLogCall = (id: number) => {
    setLogCallToDelete({ id });
    setShowDeleteLogCallModal(true);
  };
  const handleEditClickLogCall = (id: number) => {
    console.log(id, "asdad");
    setSelectedLogCallId({ id });
    fetchSelectedLogCall(id);
  }
  const fetchSelectedLogCall = async (id: number) => {
    try {
      setSelectedLogCallId({ id });
      const response = await detailLogCall(id);
      const logCallData = response.data.data;
      setLogCallDetail(logCallData);
      setEditLogCall({
        userCall: logCallData.userCall?.uuid || "",
        status: logCallData.status || "",
        followUpDate: formatDateForInput(logCallData.followUpDate),
        note: logCallData.notes || "",
        assignType: logCallData.assignType || "",
        assignRecord: logCallData.assignee?.id || 0,
        targetType: logCallData.targetType || "",
        targetRecord: logCallData.targets?.id || 0,
      });
      if (logCallData.assignType === "LEAD") {
        setAssignTaskOptions(listLeadAssignType.map(t => ({ value: t.leadId, label: t.leadName })));
      } else if (logCallData.assignType === "CONTACT") {
        setAssignTaskOptions(listContactAssignType.map(t => ({ value: t.contactId, label: t.contactName })));
      }

      if (logCallData.targetType === "ACCOUNT") {
        setRelateTaskOptions(listAccountRelatedToType.map(t => ({ value: t.accountId, label: t.accountName })));
      } else if (logCallData.targetType === "OPPORTUNITY") {
        setRelateTaskOptions(listOpportunitiesRelatedToType.map(t => ({ value: t.id, label: t.name })));
      }
      setShowEditLogCallModal(true);
    } catch (err) {
      console.error("Error fetching log calls:", err);
      setError("Failed to load log calls.");
    } finally {
      setLoading(false);
    }
  };
  const handleSelectAttendeesChange = (selectedOptions: any) => {
    setAttendees(selectedOptions);
    setNewEventData((prevData) => ({
      ...prevData,
      attendees: selectedOptions ? selectedOptions.map((option: { value: number }) => option.value) : [],
    }));
    setEditEventData({
      ...editEventData,
      attendees: selectedOptions.map((option: { value: number }) => Number(option.value)),
    });
  };
  const handleDeleteEventClick = async (eventId: number) => {
    setSelectedEventId(eventId);
    setShowDeleteModal(true);
  }
  const [newTaskData, setNewTaskData] = useState({
    title: "",
    category: "",
    responsible: "",
    startDate: "",
    endDate: "",
    status: "",
    priority: "",
    description: "",
    assignType: "",
    assignId: 0,
    targetType: "",
    targetId: 0,
  });

  const [editTaskData, setEditTaskData] = useState({
    title: "",
    category: "",
    responsible: "",
    startDate: "",
    endDate: "",
    status: "",
    priority: "",
    description: "",
    assignType: "",
    assignId: 0,
    targetType: "",
    targetId: 0,
  });
  useEffect(() => {
    console.log("id:", id);
    if (id) {
      getContactDetail(id)
        .then(response => {
          if (response?.data?.data?.contactInformation) {
            const contactData = response.data.data.contactInformation;
            const tagList = response.data.data.tagList || [];
            const campaignHistory = response.data.data.campaignHistory || [];
            const opportunityContacts = response.data.data.opportunityContacts || [];
            setContactDetail({
              ...contactData,
              tagList,
              campaignHistory,
              opportunityContacts
            });
          }
        })
        .catch(error => console.error("Error fetching contact details:", error));
    }
  }, [id]);
  const [emailContactResponse, setEmailContactResponse] = useState<EmailContactResponse[]>([]);
  const fetchEmailResponse = async () => {
    try {
      const response = await listAllEmail(contactDetail?.contactId);
      setEmailContactResponse(response.data.data || []);
    } catch (err) {
      console.error("Error fetching email: ", err);
      setError("Failed to load emails");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (contactDetail && contactDetail.contactId) {
      fetchLogCalls();
      fetchEvents();
      fetchTasks();
      fetchEmailResponse();
    }
  }, [contactDetail]);


  const [showEmailModal, setShowEmailModal] = useState(false);
  const [emailData, setEmailData] = useState({
    fromEmail: localStorage.getItem('userEmail') || "",
    contactId: 0,
    contactEmail: "",
    subject: "",
    body: ""
  });

  useEffect(() => {
    if (contactDetail) {
      setEmailData(prev => ({
        ...prev,
        contactId: contactDetail.contactId,
        contactEmail: contactDetail.email
      }));
    }
  }, [contactDetail]);

  const getEmailData = () => {
    return {
      fromEmail: emailData.fromEmail,
      contactId: emailData.contactId,
      subject: emailData.subject,
      body: emailData.body
    };
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setEmailData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSendEmail = async () => {
    try {
      const emailPayload = getEmailData();
      const response = await sendEmail(emailPayload);
      if (response.status === 200) {
        setResponse({
          status: "success",
          message: "Email sent successfully!"
        });
        setShowEmailModal(false);
        setShowMessageModal(true);
      }
    } catch (error: any) {
      console.error("Error sending email:", error);
      if (error.response?.data?.code != 500) {
        setResponse({
          status: "error",
          message: error.response?.data?.message || "Error sending email"
        });
        setShowMessageModal(true);
      }
    }
  };
  //This method 
  const fetchListLeadAssignType = async () => {
    try {
      const response = await listLeadsOption();
      setListLeadAssignType(response.data.data || []);
    } catch (err) {
      console.error("Error fetching leads: ", err);
      setError("Failed to load leads.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchListLeadAssignType();
  }, []);
  const fetchEvents = async () => {
    if (!contactDetail?.contactId) return;
    setLoading(true);
    setError("");
    try {
      const response = await ViewMemberEvent("CONTACT", contactDetail?.contactId);
      setEvents(response.data.data || []);
    } catch (err) {
      setError("Failed to load events.");
    } finally {
      setLoading(false);
    }
  };
  const fetchListContactAssignType = async () => {
    try {
      const response = await listContactsOptionn();
      setListContactAssignType(response.data.data || []);
    } catch (err) {
      console.error("Error fetching contacts: ", err);
      setError("Failed to load contacts.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchListContactAssignType();
  }, []);
  const fetchAccountRelatedToType = async () => {
    try {
      const response = await listAccountsOption();
      setListAccountRelatedToType(response.data.data || []);
    } catch (err) {
      console.error("Error fetching accounts: ", err);
      setError("Failed to load accounts.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchAccountRelatedToType();
  }, []);
  const fetchListOpportunitiesRelatedToType = async () => {
    try {
      const response = await listOpportunitiesOption();
      setListOpportunitiesRelatedToType(response.data.data || []);
    } catch (err) {
      console.error("Error fetching opportunities: ", err);
      setError("Failed to load opportunities.");
    } finally {
      setLoading(false);
    }
  };
  const fetchUserCallList = async () => {
    try {
      const userTenantId = Number(localStorage.getItem("userTenantId"));
      console.log("UserTenantIDabcabc: ", userTenantId)
      const response = await userList(userTenantId);
      setListUserCall(response.data.data || []);
    } catch (err) {
      console.error("Error fetching users:", err);
      setError("Failed to load users.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchUserCallList();
  }, []);
  useEffect(() => {
    fetchListOpportunitiesRelatedToType();
  }, []);
  useEffect(() => {
    if (newTaskData.assignType === "LEAD") {
      setAssignTaskOptions(listLeadAssignType.map(t => ({ value: t.leadId, label: t.leadName })));
    } else if (newTaskData.assignType === "CONTACT") {
      setAssignTaskOptions(listContactAssignType.map(t => ({ value: t.contactId, label: t.contactName })));
    }
    if (newLogCall.assignType === "LEAD") {
      setAssignTaskOptions(listLeadAssignType.map(t => ({ value: t.leadId, label: t.leadName })));
    } else if (newLogCall.assignType === "CONTACT") {
      setAssignTaskOptions(listContactAssignType.map(t => ({ value: t.contactId, label: t.contactName })));
    }
  }, [newTaskData.assignType, newLogCall.assignType, listLeadAssignType, listContactAssignType]);
  useEffect(() => {
    if (assignTaskOptions.length > 0) {
      setNewTaskData(prev => ({
        ...prev,
        assignId: contactDetail?.contactId ?? assignTaskOptions[0].value
      }));
    }
  }, [assignTaskOptions, contactDetail]);
  useEffect(() => {
    const userUuid = localStorage.getItem("userUuid");
    if (contactDetail) {
      setNewTaskData(prev => ({
        ...prev,
        assignType: "CONTACT",
        assignId: contactDetail?.contactId ?? 0,
        responsible: userUuid || ""
      }));
      setNewEventData(prev => ({
        ...prev,
        assignType: "CONTACT"
      }));
      setNewLogCall(prev => ({
        ...prev,
        assignType: "CONTACT",
        assignRecord: contactDetail?.contactId ?? 0,
        userCall: userUuid || ""
      }));
    }
  }, [contactDetail]);
  const [newEventData, setNewEventData] = useState({
    subject: "",
    description: "",
    attendees: [] as number[],
    location: "",
    targetType: "",
    targetIds: null as number | null,
    assignType: "",
    assigneeId: [] as number[],
    startTime: "",
    endTime: ""
  });
  const [editEventData, setEditEventData] = useState({
    subject: "",
    description: "",
    attendees: [] as number[],
    location: "",
    targetType: "",
    targetIds: null as number | null,
    assignType: "",
    assigneeId: [] as number[],
    startTime: "",
    endTime: ""
  });

  const handleUpdateTaskInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setEditLogCall((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setEditEventData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setEditingTask((prevData) => {
      if (!prevData) return prevData;
      if (name === "responsible") {
        const selectedUser = listUserCall.find(user => user.uuid === value);
        return {
          ...prevData,
          responsible: selectedUser ? { uuid: selectedUser.uuid, username: selectedUser.username } : prevData.responsible
        };
      }
      return {
        ...prevData,
        [name]: name === "memberId" || name === "assignId" || name === "targetId" ? Number(value) || 0 : value,
      };
    });
  };

  const handleUpdateTaskSelectChange = (name: string, value: string | number) => {
    setEditLogCall((prevData) => {
      if (!prevData) return prevData;

      if (name === "assignRecord") {
        return {
          ...prevData,
          assignRecord: value as number,
        };
      }

      if (name === "targetRecord") {
        return {
          ...prevData,
          targetRecord: value as number,
        };
      }

      return {
        ...prevData,
        [name]: value,
      };
    });
    setEditingTask((prevData) => {
      if (!prevData) return prevData;
      if (name === "assignId") {
        return {
          ...prevData,
          assignee: {
            ...prevData.assignee,
            id: value as number,
          },
        };
      }

      if (name === "targetId") {
        return {
          ...prevData,
          targets: {
            ...prevData.targets,
            id: value as number,
          },
        };
      }
      return {
        ...prevData,
        [name]: value,
      };
    });

  };
  const getEditEventData = (): UpdateEventDTO => {
    return {
      subject: editEventData.subject,
      description: editEventData.description,
      attendees: editEventData.attendees,
      location: editEventData.location,
      startTime: editEventData.startTime
        ? new Date(
          new Date(editEventData.startTime).getTime()
        ).toISOString()
        : new Date().toISOString(),
      endTime: editEventData.endTime
        ? new Date(
          new Date(editEventData.endTime).getTime()
        ).toISOString()
        : new Date().toISOString(),
      assignType: editEventData.assignType,
      assigneeId: editEventData.assigneeId,
      targetType: editEventData.targetType,
      targetIds: editEventData.targetIds,
    };
  };
  const handleUpdateEvent = async () => {
    if (!selectedEventId) {
      return;
    }
    try {
      const editEvent = getEditEventData();
      const response = await updateEvent(selectedEventId, editEvent);
      if (response.status === 200) {
        setResponse({ status: "success", message: "Event updated successfully!" });
        fetchEvents();
        resetEditEventForm();
        setAttendees([]);
      }
    } catch (err) {
      console.error("Error creating event:", err);
      setResponse({ status: "error", message: "Event updated failed!" });
    } finally {
      setShowMessageModal(true);
    }
  };
  const handleTaskAssignTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedType = e.target.value;

    let newOptions: { value: number; label: string }[] = [];
    if (selectedType === "LEAD") {
      newOptions = listLeadAssignType.map((t) => ({ value: t.leadId, label: t.leadName }));
    } else if (selectedType === "CONTACT") {
      newOptions = listContactAssignType.map((t) => ({ value: t.contactId, label: t.contactName }));
    }
    setAssignTaskOptions(newOptions);
    setNewLogCall((prev) => ({
      ...prev,
      assignType: selectedType,
      ...(newOptions.length > 0 && { assignRecord: newOptions[0].value })
    }));
    setEditLogCall((prev) => ({
      ...prev,
      assignType: selectedType,
      ...(newOptions.length > 0 && { assignRecord: newOptions[0].value })
    }));
    setNewTaskData((prev) => ({
      ...prev,
      assignType: selectedType,
      ...(newOptions.length > 0 && { assignId: newOptions[0].value })
    }));
    setEditTaskData((prev) => ({
      ...prev,
      assignType: selectedType,
      ...(newOptions.length > 0 && { assignId: newOptions[0].value })
    }));
    setNewEventData((prev) => ({
      ...prev,
      assignType: selectedType,
      ...(newOptions.length > 0 && { assignId: newOptions[0].value })
    }));
    setEditEventData((prev) => ({
      ...prev,
      assignType: selectedType,
      ...(newOptions.length > 0 && { assignId: newOptions[0].value })
    }));

  };
  const handleTaskRelatedToTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedType = e.target.value;

    let newOptions: { value: number; label: string }[] = [];
    if (selectedType === "ACCOUNT") {
      newOptions = listAccountRelatedToType.map((t) => ({ value: t.accountId, label: t.accountName }));
    } else if (selectedType === "OPPORTUNITY") {
      newOptions = listOpportunitiesRelatedToType.map((t) => ({ value: t.id, label: t.name }));
    }
    setRelateTaskOptions(newOptions);
    setNewLogCall((prev) => ({
      ...prev,
      targetType: selectedType,
      ...(newOptions.length > 0 && { targetRecord: newOptions[0].value })
    }));
    setEditLogCall((prev) => ({
      ...prev,
      targetType: selectedType,
      ...(newOptions.length > 0 && { targetRecord: newOptions[0].value })
    }));
    setNewTaskData((prev) => ({
      ...prev,
      targetType: selectedType,
      ...(newOptions.length > 0 && { targetId: newOptions[0].value })
    }));
    setEditTaskData((prev) => ({
      ...prev,
      targetType: selectedType,
      ...(newOptions.length > 0 && { targetId: newOptions[0].value })
    }));
    setNewEventData((prev) => ({
      ...prev,
      targetType: selectedType,
      ...(newOptions.length > 0 && { targetId: newOptions[0].value })
    }));
    setEditEventData((prev) => ({
      ...prev,
      targetType: selectedType,
      ...(newOptions.length > 0 && { targetId: newOptions[0].value })
    }));
  };
  // Fetch tasks
  useEffect(() => {
    if (id) {
      fetchTasks();
      fetchLogCalls();
    }
  }, [id]);
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setEditLogCall((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setNewTaskData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setEditTaskData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const resetNewTaskForm = () => {
    setNewTaskData({
      title: "",
      category: "",
      responsible: "",
      startDate: "",
      endDate: "",
      status: "",
      priority: "",
      description: "",
      assignType: "",
      assignId: 0,
      targetType: "",
      targetId: 0,
    });
  };

  const resetEditTaskForm = () => {
    setEditTaskData({
      title: "",
      category: "",
      responsible: "",
      startDate: "",
      endDate: "",
      status: "",
      priority: "",
      description: "",
      assignType: "",
      assignId: 0,
      targetType: "",
      targetId: 0,
    });
  };
  const getNewTaskData = (): CreateTaskDTO => {
    return {
      memberId: contactDetail?.contactId ?? 0,
      title: newTaskData.title,
      category: newTaskData.category,
      responsible: newTaskData.responsible,
      startDate: newTaskData.startDate
        ? new Date(
          new Date(newTaskData.startDate).getTime()
        ).toISOString()
        : new Date().toISOString(),
      endDate: newTaskData.endDate
        ? new Date(
          new Date(newTaskData.endDate).getTime()
        ).toISOString()
        : new Date().toISOString(),
      status: newTaskData.status,
      priority: newTaskData.priority,
      description: newTaskData.description,
      assignType: newTaskData.assignType,
      assignId: newTaskData.assignId,
      targetType: newTaskData.targetType,
      targetId: newTaskData.targetId,
    };
  };
  const getEditTaskData = (): UpdateTaskDTO => {
    return {
      memberId: contactDetail?.contactId ?? 0,
      title: editTaskData.title,
      category: editTaskData.category,
      responsible: editTaskData.responsible,
      startDate: editTaskData.startDate
        ? new Date(
          new Date(editTaskData.startDate).getTime()
        ).toISOString()
        : new Date().toISOString(),
      endDate: editTaskData.endDate
        ? new Date(
          new Date(editTaskData.endDate).getTime()
        ).toISOString()
        : new Date().toISOString(),
      status: editTaskData.status,
      priority: editTaskData.priority,
      description: editTaskData.description,
      assignType: editTaskData.assignType,
      assignId: editTaskData.assignId,
      targetType: editTaskData.targetType,
      targetId: editTaskData.targetId,
    };
  };
  const fetchTasks = async () => {
    try {
      const response = await viewContactTasks("CONTACT", id);
      console.log("Tasks:", response.data);
      setTasks(response.data.data || []);
    } catch (error) {
      console.error("Error fetching tasks:", error);
    }
  };
  const handleCreateTasks = async () => {
    try {
      const newTask = getNewTaskData();
      const response = await createTask(newTask);
      if (response.status === 200) {
        setResponse({ status: "success", message: "Task created successfully!" });
        resetNewTaskForm();
        fetchTasks();
        document.body.classList.remove("modal-open");
        document.body.style.overflow = "auto";
        setShowMessageModal(true);
      }
    } catch (error: any) {
      if (error.response?.data?.code != 500) {
        setResponse({ status: "error", message: error.response.data.message || "Updated failed" });
        document.body.classList.remove("modal-open");
        document.body.style.overflow = "auto";
        setShowMessageModal(true);
      }
    }
  };
  const handleUpdateTask = async (taskId: number) => {
    try {
      const updatedTask = getEditTaskData();
      const response = await updateTask(taskId, updatedTask);
      if (response.status === 200) {
        setResponse({ status: "success", message: "Task updated successfully!" });
        fetchTasks();
        resetEditTaskForm();
        document.body.classList.remove("modal-open");
        document.body.style.overflow = "auto";
        setShowMessageModal(true);
      }
    } catch (error: any) {
      if (error.response?.data?.code != 500) {
        setResponse({ status: "error", message: error.response.data.message || "Updated failed" });
        document.body.classList.remove("modal-open");
        document.body.style.overflow = "auto";
        setShowMessageModal(true);
      }
    }
  };

  // Fetch log calls
  const fetchLogCalls = async () => {
    try {
      const response = await viewContactLogCalls("CONTACT", id);
      console.log("Log Calls:", response.data);
      setLogCalls(response.data.data || []);
    } catch (error) {
      console.error("Error fetching log calls:", error);
    }
  };

  // Task handlers
  const handleTaskCategoryChange = (selectedOption: any) => {
    setTaskCategory(selectedOption?.value);
  };

  const handleTaskStatusChange = (selectedOption: any) => {
    setTaskStatus(selectedOption?.value);
  };

  const handleTaskPriorityChange = (selectedOption: any) => {
    setTaskPriority(selectedOption?.value);
  };
  const handleEditClickTask = (id: number) => {
    console.log(id, "asdad");
    setSelectedTaskId({ id });
    fetchSelectedTask(id);
  }
  const fetchSelectedTask = async (id: number) => {
    try {
      setSelectedTaskId({ id: id });
      const response = await detailTask(id);
      console.log(response.data.data, "hihihhehehe");
      setEditingTask(response.data.data);

    } catch (err) {
      console.error("Error fetching task.", err);
      setError("Failed to load task.");
    } finally {
      setLoading(false);
    }
  };
  const handleDeleteClickTask = (id: number) => {
    setTaskToDelete({ id });
  };
  const handleEditClickEvent = (id: number) => {
    setSelectedEventId(id);
    fetchSelectedEvent(id);
  }
  const fetchSelectedEvent = async (id: number) => {
    try {
      const response = await getEventDetail(id);
      const eventData = response.data.data as EventDetailDTO;
      setEventDetail({
        ...eventData,
        attendees: eventData.attendees || [],
        assignee: eventData.assignee || []
      });
      setEditEventData({
        subject: eventData.subject || "",
        description: eventData.description || "",
        attendees: eventData.attendees?.map(att => att.id) || "",
        location: eventData.location || "",
        assignType: eventData.assignType || "",
        assigneeId: eventData.assignee?.map(ass => ass.id) || 0,
        targetType: eventData.targetType || "",
        targetIds: eventData.targets ? eventData.targets.id : 0,
        startTime: formatDateForInput(eventData.startTime),
        endTime: formatDateForInput(eventData.endTime),
      });
      console.log("EventDetailabcxyz: ", editEventData)
    } catch (err) {
      console.error("Error fetching event details:", err);
    }
  };
  const handleEditTask = (task: any) => {
    setEditingTask(task);
    setTaskTitle(task.title);
    setTaskCategory(task.category);
    setTaskResponsible(task.responsible || "");
    setTaskStartDate(task.startDate ? new Date(task.startDate).toISOString().slice(0, 16) : "");
    setTaskEndDate(task.endDate ? new Date(task.endDate).toISOString().slice(0, 16) : "");
    setTaskStatus(task.status);
    setTaskPriority(task.priority);
    setTaskDescription(task.description || "");
    setShowTaskModal(true);
  };

  const handleDeleteTask = (taskId: number) => {
    setTaskToDelete({ id: taskId });
    setShowDeleteTaskModal(true);
  };

  const handleConfirmDeleteTask = async () => {
    if (!taskToDelete) return;

    try {
      const response = await deleteContactTask(taskToDelete.id);
      if (response.status === 200) {
        console.log("Task deleted successfully");
        setTasks((prevTasks) =>
          prevTasks.filter((task) => task.id !== taskToDelete.id)
        );
        setShowDeleteTaskModal(false);
      }
    } catch (error) {
      console.error("Error deleting task:", error);
    }
  };

  const handleCreateTask = async () => {
    if (!taskTitle || !taskCategory || !taskStatus || !taskPriority) {
      alert("Vui lòng điền đầy đủ thông tin bắt buộc");
      return;
    }

    const taskData = {
      memberId: contactDetail?.contactId || 0,
      title: taskTitle,
      category: taskCategory,
      responsible: taskResponsible,
      startDate: taskStartDate
        ? new Date(new Date(taskStartDate).getTime() + 7 * 60 * 60 * 1000).toISOString()
        : new Date(new Date().getTime() + 7 * 60 * 60 * 1000).toISOString(),
      endDate: taskEndDate
        ? new Date(new Date(taskEndDate).getTime() + 7 * 60 * 60 * 1000).toISOString()
        : null,
      status: taskStatus,
      priority: taskPriority,
      description: taskDescription,
      assignType: "CONTACT",
      assignId: contactDetail?.contactId || 0,
      targetType: "CONTACT",
      targetId: contactDetail?.contactId || 0
    };

    try {
      if (editingTask) {
        const response = await updateContactTask(selectedTaskId, taskData);
        if (response.status === 200) {
          console.log("Task updated successfully");
          fetchTasks();
        }
      } else {
        // Create new task
        const response = await createContactTask(taskData);
        if (response.status === 200) {
          console.log("Task created successfully");
          fetchTasks();
        }
      }

      // Reset form
      setTaskTitle("");
      setTaskCategory("");
      setTaskResponsible("");
      setTaskStartDate("");
      setTaskEndDate("");
      setTaskStatus("");
      setTaskPriority("");
      setTaskDescription("");
      setEditingTask(null);
      setShowTaskModal(false);

    } catch (error) {
      console.error("Error saving task:", error);
    }
  };

  // Call handlers
  const handleLogCallStatusChange = (selectedOption: any) => {
    setLogCallStatus(selectedOption?.value);
  };

  const handleUserCallChange = (selectedOption: any) => {
    setLogCallUserCall(selectedOption?.value);
  };

  const handleFollowUpDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLogCallFollowUpDate(event.target.value);
  };

  const handleNoteChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setLogCallNote(e.target.value);
  };

  const handleCreateFollowingTaskChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLogCallCreateFollowingTask(e.target.checked);
  };

  const handleEditCall = (logCall: any) => {
    setEditingLogCall(logCall);
    setLogCallStatus(logCall.status);
    setLogCallUserCall(logCall.userCall || "");
    setLogCallFollowUpDate(logCall.followUpTime ? new Date(logCall.followUpTime).toISOString().slice(0, 16) : "");
    setLogCallNote(logCall.notes || "");
    setShowEditCallModal(true);
  };

  const handleDeleteCall = (callId: number) => {
    setLogCallToDelete({ id: callId });
    setShowDeleteCallModal(true);
  };


  const handleConfirmDeleteCall = async () => {
    if (!logCallToDelete) return;
    try {
      const response = await deleteContactLogCall(logCallToDelete.id);
      if (response.status === 200) {
        console.log("Log call deleted successfully");
        setLogCalls((prevCalls) =>
          prevCalls.filter((call) => call.id !== logCallToDelete.id)
        );
        setShowDeleteCallModal(false);
        setResponse({ status: "success", message: "Log call deleted successfully!" });
        setShowMessageModal(true);
      }
    } catch (error: any) {
      if (error.response?.data?.code != 500) {
        setResponse({ status: "error", message: error.response.data.message || "Updated failed" });
        setShowMessageModal(true);
      }
    }
  };
  const attendeesOptions = listUserCall.map((user) => ({
    value: user.id,
    label: user.username,
  }));
  const selectedAttendees = attendeesOptions.filter(option =>
    editEventData.attendees.includes(option.value)
  );
  const resetAddLogCallForm = () => {
    setNewLogCall({
      userCall: "",
      status: "",
      followUpDate: "",
      note: "",
      assignType: "",
      assignRecord: 0,
      targetType: "",
      targetRecord: 0,
      checkedCreateFollowingTask: false,
    });
  };
  const handleCreateLogCall = async () => {
    try {
      const logCallData = getNewLogCallData();
      const response = await createLogCall(logCallData);
      if (response.status === 200) {
        setResponse({ status: "success", message: "Log call created successfully!" });
        fetchLogCalls();
        resetAddLogCallForm();
        setShowMessageModal(true);
      }
    } catch (error: any) {
      if (error.response?.data?.code != 500) {
        setResponse({ status: "error", message: error.response.data.message || "Updated failed" });
        setShowMessageModal(true);
      }
    }
  };
  const resetNewEventForm = () => {
    setNewEventData({
      subject: "",
      description: "",
      attendees: [] as number[],
      location: "",
      targetType: "",
      targetIds: null as number | null,
      assignType: "",
      assigneeId: [] as number[],
      startTime: "",
      endTime: ""
    });
  };
  const resetEditEventForm = () => {
    setEditEventData({
      subject: "",
      description: "",
      attendees: [] as number[],
      location: "",
      targetType: "",
      targetIds: null as number | null,
      assignType: "",
      assigneeId: [] as number[],
      startTime: "",
      endTime: ""
    });
  };
  const getNewEventData = (): CreateEventDTO => {
    return {
      subject: newEventData.subject,
      description: newEventData.description,
      attendees: newEventData.attendees,
      location: newEventData.location,
      startTime: newEventData.startTime
        ? new Date(
          new Date(newEventData.startTime).getTime()
        ).toISOString()
        : new Date().toISOString(),
      endTime: newEventData.endTime
        ? new Date(
          new Date(newEventData.endTime).getTime()
        ).toISOString()
        : new Date().toISOString(),
      assignType: newEventData.assignType,
      assigneeId: newEventData.assigneeId,
      targetType: newEventData.targetType,
      targetIds: newEventData.targetIds,
    };
  };
  const handleCreateEvent = async () => {
    try {
      const newEvent = getNewEventData();
      const response = await createEvent(newEvent);
      if (response.status === 200) {
        setResponse({ status: "success", message: "Event created successfully!" });
        fetchEvents();
        resetNewEventForm();
        setAttendees([]);
        setShowMessageModal(true);
      }
    } catch (error: any) {
      if (error.response?.data?.code != 500) {
        setResponse({ status: "error", message: error.response.data.message || "Updated failed" });
        setShowMessageModal(true);
      }
    }
  };
  const handleUpdateLogCall = async (logCallId: number) => {
    if (!editLogCall) return;
    const updatedLogCall: LogCallDataUpdate = {
      userCall: editLogCall.userCall || "",
      status: editLogCall.status ?? "",
      followUpDate: editLogCall.followUpDate
        ? new Date(editLogCall.followUpDate).toISOString()
        : "",
      note: editLogCall.note ?? "",
      assignType: editLogCall.assignType,
      assignRecord: editLogCall.assignRecord,
      targetType: editLogCall.targetType,
      targetRecord: editLogCall.targetRecord,
    };

    try {
      const response = await updateLogCall(logCallId, updatedLogCall);
      if (response.status === 200) {
        setResponse({ status: "success", message: "Log call updated successfully" });
        setShowMessageModal(true);
        fetchLogCalls();
      }
    } catch (error: any) {
      if (error.response?.data?.code != 500) {
        setResponse({ status: "error", message: error.response.data.message || "Updated failed" });
        setShowMessageModal(true);
      }
    }
  };

  const handleUpdateLogCallStatus = async (id: number, status: string) => {
    try {
      const response = await updateContactLogCallStatus(id, status);
      if (response.status === 200) {
        setResponse({ status: "success", message: "Log call status updated successfully" });
        setShowMessageModal(true);
        fetchLogCalls();
      }
    } catch (error: any) {
      if (error.response?.data?.code != 500) {
        setResponse({ status: "error", message: error.response.data.message || "Updated failed" });
        setShowMessageModal(true);
      }
    }
  };

  const [openModal, setOpenModal] = useState(false);
  const [isEditor, setIsEditor] = useState(false);
  const [isEditor2, setIsEditor2] = useState(false);
  const [isEditor3, setIsEditor3] = useState(false);
  const [owner, setOwner] = useState(["Collab"]);
  const [selectedDate1, setSelectedDate1] = useState<Date | null>(new Date());
  const handleDateChange1 = (date: Date | null) => {
    setSelectedDate1(date);
  };

  const [selectedDate, setSelectedDate] = useState<Date | null>(new Date());
  const handleDateChange = (date: Date | null) => {
    setSelectedDate(date);
  };
  const [selectedDate2, setSelectedDate2] = useState<Date | null>(new Date());
  const handleDateChange2 = (date: Date | null) => {
    setSelectedDate2(date);
  };
  const [selectedDate4, setSelectedDate4] = useState<Date | null>(new Date());
  const handleDateChange4 = (date: Date | null) => {
    setSelectedDate4(date);
  };
  const dealsopen = [
    { value: "choose", label: "Choose" },
    { value: "collins", label: "Collins" },
    { value: "konopelski", label: "Konopelski" },
    { value: "adams", label: "Adams" },
    { value: "schumm", label: "Schumm" },
    { value: "wisozk", label: "Wisozk" },
  ];
  const activities = [
    { value: "choose", label: "Choose" },
    { value: "phoneCalls", label: "Phone Calls" },
    { value: "socialMedia", label: "Social Media" },
    { value: "referralSites", label: "Referral Sites" },
    { value: "webAnalytics", label: "Web Analytics" },
    { value: "previousPurchases", label: "Previous Purchases" },
  ];
  const industries = [
    { value: "choose", label: "Choose" },
    { value: "Retail Industry", label: "Retail Industry" },
    { value: "Banking", label: "Banking" },
    { value: "Hotels", label: "Hotels" },
    { value: "Financial Services", label: "Financial Services" },
    { value: "Insurance", label: "Insurance" },
  ];
  const countries = [
    { value: "Choose", label: "Choose" },
    { value: "India", label: "India" },
    { value: "USA", label: "USA" },
    { value: "France", label: "France" },
    { value: "UAE", label: "UAE" },
  ];
  const languages = [
    { value: "Choose", label: "Choose" },
    { value: "English", label: "English" },
    { value: "Arabic", label: "Arabic" },
    { value: "Chinese", label: "Chinese" },
    { value: "Hindi", label: "Hindi" },
  ];
  const emails = [
    {
      subject: "Meeting Reminder",
      body: "This is a reminder for our meeting tomorrow.",
      createdAt: "2025-04-05T10:00:00Z",
      createdBy: "John Doe",
      childEmailLogs: [
        {
          subject: "Meeting Confirmation",
          body: "Looking forward to our meeting tomorrow!",
          createdAt: "2025-04-05T10:00:00Z"
        },
        {
          subject: "Agenda Details",
          body: "Please find the agenda attached.",
          createdAt: "2025-04-05T10:00:00Z"
        },
      ],
    },
    {
      subject: "Project Update",
      body: "Here is the latest project update.",
      createdAt: "2025-04-04T15:30:00Z",
      createdBy: "Jane Smith",
      childEmailLogs: [
        {
          subject: "Update Received",
          body: "Thanks for the update, I'll check it out.",
          createdAt: "2025-04-05T10:00:00Z"
        },
      ],
    },
  ];
  const handleSelectChange = (e: any, field: string) => {
    setEditLogCall((prev) => {
      if (!prev) return prev;
      return {
        ...prev,
        [field]: field === "userCall" ? e.target.value : e?.target?.value || e.value,
      };
    });
    setEditingTask((prev) => {
      if (!prev) return prev;
      return {
        ...prev,
        [field]: e?.target ? e.target.value : e.value
      };
    });
    setEditEventData((prev) => {
      if (!prev) return prev;
      return {
        ...prev,
        [field]: e?.target ? e.target.value : e.value
      };
    });
  };
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              {/* Page Header */}
              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col-sm-4">
                    <h4 className="page-title">
                      Contacts
                    </h4>
                  </div>
                </div>
              </div>
              {/* /Page Header */}
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              {/* Contact User */}
              <div className="contact-head">
                <div className="row align-items-center">
                  <div className="col-sm-6">
                    <ul className="contact-breadcrumb">
                      <li>
                        <Link to={route.contactList}>
                          <i className="ti ti-arrow-narrow-left" />
                          Contacts
                        </Link>
                      </li>
                      <li>{contactDetail?.firstName} {contactDetail?.lastName} </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-body pb-2">
                  <div className="d-flex align-items-center justify-content-between flex-wrap">
                    <div className="d-flex align-items-center mb-2">
                      <div>
                        <h5 className="mb-1">{contactDetail?.salutation}. {contactDetail?.firstName} {contactDetail?.lastName}</h5>
                        <p className="mb-0">{contactDetail?.title}</p>
                        <a className="mb-2">{contactDetail?.accountName}</a>
                      </div>
                    </div>
                    <div className="contacts-action">
                      <Link
                        to="#"
                        className="btn btn-primary"
                        onClick={() => setShowEmailModal(true)}
                      >
                        <i className="ti ti-mail" />
                        Send Email
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Contact User */}
            </div>
            {/* Contact Sidebar
  contactId: number;
  accountId: number;
  accountName: string;
  title: string;
  salutation: string;
  contactOwnerUuid: string;
  contactOwnerName: string | null;
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  mobileNumber: string;
  reportToId: number | null;
  reportToName: string | null;
  fax: string;
  department: string;
  mailingStreet: string | null;
  mailingCity: string | null;
  mailingState: string | null;
  mailingZip: string | null;
  mailingCountry: string | null;
  description: string | null;
  createdBy: string;
  updatedBy: string;
  campaignHistory: any[];
  opportunityContacts: any[];
            */}
            <div className="col-xl-3 theiaStickySidebar">
              <div className="card">
                <div className="card-body p-3">
                  <h6 className="mb-3 fw-semibold">Basic Information</h6>
                  <div className="mb-3">
                    <div className="d-flex align-items-center mb-3">
                      <span className="avatar avatar-xs bg-light-300 p-0 flex-shrink-0 rounded-circle text-dark me-2">
                        <i className="ti ti-mail" />
                      </span>
                      <span className="col-4">Email</span>
                      <span className="col-7">{contactDetail?.email || "N/A"}</span>
                    </div>
                    <div className="d-flex align-items-center mb-3">
                      <span className="avatar avatar-xs bg-light-300 p-0 flex-shrink-0 rounded-circle text-dark me-2">
                        <i className="ti ti-phone" />
                      </span>
                      <span className="col-4">Phone</span>
                      <span className="col-7">{contactDetail?.phoneNumber || "N/A"}</span>
                    </div>
                    <div className="d-flex align-items-center mb-3">
                      <span className="avatar avatar-xs bg-light-300 p-0 flex-shrink-0 rounded-circle text-dark me-2">
                        <i className="ti ti-phone" />
                      </span>
                      <span className="col-4">Mobile</span>
                      <span className="col-7">{contactDetail?.mobileNumber || "N/A"}</span>

                    </div>
                    <div className="d-flex align-items-center mb-3">
                      <span className="avatar avatar-xs bg-light-300 p-0 flex-shrink-0 rounded-circle text-dark me-2">
                        <i className="ti ti-phone" />
                      </span>
                      <span className="col-4">Fax</span>
                      <span className="col-7">{contactDetail?.fax || "N/A"}</span>
                    </div>
                    <div className="d-flex align-items-center mb-3">
                      <span className="avatar avatar-xs bg-light-300 p-0 flex-shrink-0 rounded-circle text-dark me-2">
                        <i className="ti ti-map-pin" />
                      </span>
                      <span className="col-4">Department</span>
                      <span className="col-7">{contactDetail?.department || "N/A"}</span>
                    </div>
                    <div className="d-flex align-items-center mb-3">
                      <span className="avatar avatar-xs bg-light-300 p-0 flex-shrink-0 rounded-circle text-dark me-2">
                        <i className="ti ti-map-pin" />
                      </span>
                      <span className="col-4">Address</span>
                      <span className="col-7">{contactDetail?.mailingStreet || "N/A"},{contactDetail?.mailingCity || "N/A"},{contactDetail?.mailingCountry || "N/A"}</span>
                    </div>
                    <div className="d-flex align-items-center mb-3">
                      <span className="avatar avatar-xs bg-light-300 p-0 flex-shrink-0 rounded-circle text-dark me-2">
                        <i className="ti ti-calendar-exclamation" />
                      </span>
                      <span className="col-4">Created By</span>
                      <span className="col-7">{contactDetail?.createdBy}</span>
                    </div>
                    <div className="d-flex align-items-center mb-3">
                      <span className="avatar avatar-xs bg-light-300 p-0 flex-shrink-0 rounded-circle text-dark me-2">
                        <i className="ti ti-calendar-exclamation" />
                      </span>
                      <span className="col-4">Modified By</span>
                      <span className="col-7">{contactDetail?.updatedBy}</span>
                    </div>
                  </div>
                  <hr />
                  <h6 className="mb-3 fw-semibold">Owner</h6>
                  <ul>
                    <li className="row mb-3">
                      <span className="col-6">{contactDetail?.contactOwnerName}</span>
                    </li>
                  </ul>
                  <hr />
                  <h6 className="mb-3 fw-semibold">Tags</h6>
                  <div className="mb-3">
                    {contactDetail?.tagList && contactDetail?.tagList.length > 0 ? (
                      contactDetail?.tagList.map((tag, index) => (
                        <Link
                          key={index}
                          to="#"
                          className="badge badge-soft-success fw-medium me-2"
                        >
                          {tag.name}
                        </Link>
                      ))
                    ) : (
                      <span className="text-muted">No tags available</span>
                    )}
                  </div>
                  <hr />
                  <div className="d-flex align-items-center justify-content-between flex-wrap">
                    <h6 className="mb-3 fw-semibold">Company</h6>
                  </div>
                  <div className="mb-3">
                    <div className="d-flex align-items-center">
                      <span className="avatar avatar-lg rounded me-2 border">
                        <ImageWithBasePath
                          src="assets/img/icons/company.svg"
                          alt=""
                          className="img-fluid w-auto h-auto"
                        />
                      </span>
                      <div>
                        <h6 className="fw-medium mb-1">
                          <Link
                            to={`/crm/company-details/${contactDetail?.accountId}`}
                            className="text-decoration-none text-dark"
                          >
                            {contactDetail?.accountName}
                          </Link>{" "}
                          <i className="fa-solid fa-circle-check text-success" />
                        </h6>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <h6 className="mb-3 fw-semibold">Social Profile</h6>
                  <ul className="social-info">
                    <li>
                      <a href={getValidUrl(contactDetail?.facebook)} target="_blank" rel="noopener noreferrer">
                        <i className="fa-brands fa-facebook-f" />
                      </a>
                    </li>
                    <li>
                      <a href={getValidUrl(contactDetail?.skype)} target="_blank" rel="noopener noreferrer">
                        <i className="fa-brands fa-skype" />
                      </a>
                    </li>
                    <li>
                      <a href={getValidUrl(contactDetail?.linkedin)} target="_blank" rel="noopener noreferrer">
                        <i className="fa-brands fa-linkedin" />
                      </a>
                    </li>
                    <li>
                      <a href={getValidUrl(contactDetail?.twitter)} target="_blank" rel="noopener noreferrer">
                        <i className="fa-brands fa-twitter" />
                      </a>
                    </li>
                    <li>
                      <a href={getValidUrl(contactDetail?.instagram)} target="_blank" rel="noopener noreferrer">
                        <i className="fa-brands fa-instagram" />
                      </a>
                    </li>
                    <li>
                      <a href={getValidUrl(contactDetail?.whatsapp)} target="_blank" rel="noopener noreferrer">
                        <i className="fa-brands fa-whatsapp" />
                      </a>
                    </li>
                  </ul>


                  <hr />
                  {/* <h6 className="mb-3 fw-semibold">Settings</h6>
                  <div className="mb-0">
                    <Link to="#" className="d-block mb-3">
                      <i className="ti ti-share-2 me-1" />
                      Share Contact
                    </Link>
                    <Link to="#" className="d-block mb-3">
                      <i className="ti ti-star me-1" />
                      Add to Favourite
                    </Link>
                    <Link
                      to="#"
                      className="d-block mb-0"
                      data-bs-toggle="modal"
                      data-bs-target="#delete_contact"
                    >
                      <i className="ti ti-trash-x me-1" />
                      Delete Contact
                    </Link>
                  </div> */}
                </div>
              </div>
            </div>
            {/* /Contact Sidebar */}
            {/* Contact Details */}
            <div className="col-xl-9">
              <div className="card mb-3">
                <div className="card-body pb-0 pt-2">
                  <ul className="nav nav-tabs nav-tabs-bottom" role="tablist">
                    <li className="nav-item" role="presentation">
                      <Link
                        to="#"
                        data-bs-toggle="tab"
                        data-bs-target="#activities"
                        className="nav-link active"
                        onClick={() => setReloadActivity(!reloadActivity)}
                      >
                        <i className="ti ti-alarm-minus me-1" />
                        Activities
                      </Link>
                    </li>
                    <li className="nav-item" role="presentation">
                      <Link
                        to="#"
                        data-bs-toggle="tab"
                        data-bs-target="#tasks"
                        className="nav-link"
                      >
                        <i className="ti ti-list-check me-1" />
                        Tasks
                      </Link>
                    </li>
                    <li className="nav-item" role="presentation">
                      <Link
                        to="#"
                        data-bs-toggle="tab"
                        data-bs-target="#events"
                        className="nav-link"
                      >
                        <i className="ti ti-calendar-event me-1" />
                        Events
                      </Link>
                    </li>
                    <li className="nav-item" role="presentation">
                      <Link
                        to="#"
                        data-bs-toggle="tab"
                        data-bs-target="#calls"
                        className="nav-link"
                      >
                        <i className="ti ti-phone me-1" />
                        Calls
                      </Link>
                    </li>
                    <li className="nav-item" role="presentation">
                      <Link
                        to="#"
                        data-bs-toggle="tab"
                        data-bs-target="#email"
                        className="nav-link"
                      >
                        <i className="ti ti-mail-check me-1" />
                        Email
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              {/* Tab Content */}
              <div className="tab-content pt-0">
                {/* Activities */}
                <ActivityList id={id} type={ACTIVITY_TYPES.CONTACT} reload={reloadActivity} />
                {/* /Activities */}
                {/* Events */}
                <div className="tab-pane fade" id="events">
                  <div className="card">
                    <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                      <h4 className="fw-semibold">Events</h4>
                      <div className="d-inline-flex align-items-center">
                        <button
                          className="btn btn-primary me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#create_event"
                        >
                          <i className="ti ti-plus"></i> Add New Event
                        </button>
                        <div className="form-sort mt-0">
                          <i className="ti ti-sort-ascending-2" />
                          <Select
                            className="select"
                            options={ascendingandDecending}
                            placeholder="Ascending"
                            classNamePrefix="react-select"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="card-body">
                      {loading ? (
                        <p>Loading events...</p>
                      ) : error ? (
                        <p className="text-danger">{error}</p>
                      ) : events.length === 0 ? (
                        <div className="text-center p-5">
                          <div className="avatar avatar-lg bg-light-primary rounded-circle mb-2">
                            <i className="ti ti-calendar-event fs-24 text-primary"></i>
                          </div>
                          <h5>No events yet</h5>
                          <p className="text-muted">Create your first event by clicking the button above</p>
                        </div>
                      ) : (
                        events.map((event) => (
                          <div key={event.id} className="card border shadow-none mb-3">
                            <div className="card-body p-3">
                              <div className="d-flex">
                                <span className="avatar avatar-md flex-shrink-0 rounded me-2 bg-success">
                                  <i className="ti ti-calendar-event text-white"></i>
                                </span>
                                <div className="w-100">
                                  <div className="d-flex justify-content-between align-items-center mb-1">
                                    <h6 className="fw-medium mb-0">Subject : {event.subject}</h6>
                                    <div className="dropdown">
                                      <Link
                                        to="#"
                                        className="action-icon"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                      >
                                        <i className="fa fa-ellipsis-v"></i>
                                      </Link>
                                      <div className="dropdown-menu dropdown-menu-right">
                                        <Link
                                          to="#"
                                          className="dropdown-item"
                                          data-bs-toggle="modal"
                                          data-bs-target="#edit_event"
                                          onClick={() => handleEditClickEvent(event.id)}
                                        >
                                          <i className="ti ti-edit text-blue"></i> Edit
                                        </Link>
                                        <Link
                                          to="#"
                                          className="dropdown-item"
                                          onClick={() => handleDeleteEventClick(event.id)}
                                        >
                                          <i className="ti ti-trash text-danger"></i> Delete
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                  <p className="mb-1">Description: {event.description || "No description"}</p>
                                  <div className="d-flex flex-wrap gap-2 mb-1">
                                    <span className="badge bg-success">
                                      Start Time: {new Date(event.startTime).toLocaleString()}
                                    </span>
                                    <span className="badge bg-danger">
                                      End Time: {new Date(event.endTime).toLocaleString()}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      )}
                    </div>

                  </div>
                </div>
                {/* Events */}
                {/* Calls */}
                <div className="tab-pane fade" id="calls">
                  <div className="card">
                    <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                      <h4 className="fw-semibold">Calls</h4>
                      <div>
                        <div className="d-flex">
                          <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#create_call">
                            <i className="ti ti-plus"></i> Add New Log Call
                          </button>
                          <div className="form-sort mt-0">
                            <i className="ti ti-sort-ascending-2" />
                            <Select
                              className="select"
                              options={ascendingandDecending}
                              placeholder="Ascending"
                              classNamePrefix="react-select"
                            />
                          </div>
                        </div>
                      </div>

                    </div>
                    <div className="card-body">
                      {logCalls.length > 0 ? (
                        logCalls.map((call, index) => (
                          <div key={index} className="card border shadow-none mb-3">
                            <div className="card-body p-3">
                              <div className="d-flex">
                                <span className="avatar avatar-md flex-shrink-0 rounded me-2 bg-secondary-success">
                                  <i className="ti ti-phone" />
                                </span>
                                <div className="w-100">
                                  <div className="d-flex justify-content-between align-items-center mb-1">
                                    <div>
                                      <span className="badge bg-primary me-2">{call.userCall || 'Unknown User'}</span>
                                      <span
                                        className={`badge ${call.status === 'BUSY' ? 'bg-danger' :
                                          call.status === 'NO_ANSWER' ? 'bg-warning' :
                                            call.status === 'LEFT_VOICE_MESSAGE' ? 'bg-info' :
                                              call.status === 'MOVING_FORWARD' ? 'bg-success' :
                                                'bg-secondary'
                                          }`}
                                      >
                                        {call.status?.replace(/_/g, ' ')}
                                      </span>
                                    </div>
                                    <div className="dropdown">
                                      <Link
                                        to="#"
                                        className="action-icon"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                      >
                                        <i className="fa fa-ellipsis-v"></i>
                                      </Link>
                                      <div className="dropdown-menu dropdown-menu-right">
                                        <Link
                                          to="#"
                                          data-bs-toggle="modal"
                                          data-bs-target="#edit_call"
                                          className="dropdown-item"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            handleEditClickLogCall(call.id);
                                          }}
                                        >
                                          <i className="ti ti-edit text-blue me-1" />
                                          Edit
                                        </Link>
                                        <Link
                                          to="#"
                                          data-bs-toggle="modal"
                                          data-bs-target="#delete_logcall"
                                          className="dropdown-item"
                                          onClick={() => handleDeleteClickLogCall(call.id)}
                                        >
                                          <i className="ti ti-trash text-danger me-1" />
                                          Delete
                                        </Link>

                                      </div>
                                    </div>
                                  </div>
                                  <p className="mb-1">{call.notes || 'No notes'}</p>
                                  <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                      <p className="mb-0 text-muted small">
                                        <i className="ti ti-calendar me-1"></i>
                                        {call.callTime ? `Call time: ${new Date(call.callTime).toLocaleString()}` : 'No call time'}
                                      </p>
                                      <p className="mb-0 text-muted small">
                                        <i className="ti ti-calendar-event me-1"></i>
                                        {call.followUpTime ? `Follow-up: ${new Date(call.followUpTime).toLocaleString()}` : 'No follow-up'}
                                      </p>
                                    </div>
                                    <div className="dropdown">
                                      <button
                                        className={`btn btn-sm ${call.status === 'BUSY' ? 'btn-danger' :
                                          call.status === 'NO_ANSWER' ? 'btn-warning' :
                                            call.status === 'LEFT_VOICE_MESSAGE' ? 'btn-info' :
                                              call.status === 'MOVING_FORWARD' ? 'btn-success' :
                                                'btn-secondary'
                                          } dropdown-toggle`}
                                        data-bs-toggle="dropdown"
                                      >
                                        {call.status?.replace(/_/g, ' ')}
                                      </button>
                                      <div className="dropdown-menu">
                                        <Link
                                          className="dropdown-item"
                                          to="#"
                                          onClick={() => handleUpdateLogCallStatus(call.id, 'BUSY')}
                                        >
                                          Busy
                                        </Link>
                                        <Link
                                          className="dropdown-item"
                                          to="#"
                                          onClick={() => handleUpdateLogCallStatus(call.id, 'NO_ANSWER')}
                                        >
                                          No Answer
                                        </Link>
                                        <Link
                                          className="dropdown-item"
                                          to="#"
                                          onClick={() => handleUpdateLogCallStatus(call.id, 'UNAVAILABLE')}
                                        >
                                          Unavailable
                                        </Link>
                                        <Link
                                          className="dropdown-item"
                                          to="#"
                                          onClick={() => handleUpdateLogCallStatus(call.id, 'WRONG_NUMBER')}
                                        >
                                          Wrong Number
                                        </Link>
                                        <Link
                                          className="dropdown-item"
                                          to="#"
                                          onClick={() => handleUpdateLogCallStatus(call.id, 'LEFT_VOICE_MESSAGE')}
                                        >
                                          Left Voice Message
                                        </Link>
                                        <Link
                                          className="dropdown-item"
                                          to="#"
                                          onClick={() => handleUpdateLogCallStatus(call.id, 'MOVING_FORWARD')}
                                        >
                                          Moving Forward
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="text-center p-5">
                          <div className="avatar avatar-lg bg-light-primary rounded-circle mb-2">
                            <i className="ti ti-phone-call fs-24 text-primary"></i>
                          </div>
                          <h5>No calls logged yet</h5>
                          <p className="text-muted">Log your first call by clicking the button above</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                {/* /Calls */}
                {/* Tasks */}
                <div className="tab-pane fade" id="tasks">
                  <div className="card">
                    <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                      <h4 className="fw-semibold">Tasks</h4>
                      <div>
                        <div className="d-flex">
                          <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#create_task">
                            <i className="ti ti-plus"></i> Add New Task
                          </button>
                          <div className="form-sort mt-0">
                            <i className="ti ti-sort-ascending-2" />
                            <Select
                              className="select"
                              options={ascendingandDecending}
                              placeholder="Ascending"
                              classNamePrefix="react-select"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card-body">
                      {/* Task list section */}
                      {tasks.length > 0 ? (
                        tasks.map((task, index) => (
                          <div key={index} className="card border shadow-none mb-3">
                            <div className="card-body p-3">
                              <div className="d-flex">
                                <span className="avatar avatar-md flex-shrink-0 rounded me-2 bg-info">
                                  <i className="ti ti-notes" />
                                </span>
                                <div className="w-100">
                                  <div className="d-flex justify-content-between align-items-center mb-1">
                                    <h6 className="fw-medium mb-0">{task.title}</h6>
                                    <div className="dropdown">
                                      <Link
                                        to="#"
                                        className="action-icon"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                      >
                                        <i className="fa fa-ellipsis-v"></i>
                                      </Link>
                                      <div className="dropdown-menu dropdown-menu-right">
                                        <Link
                                          to="#"
                                          data-bs-toggle="modal"
                                          data-bs-target="#edit_task"
                                          className="dropdown-item"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            handleEditClickTask(task.id);
                                          }}
                                        >
                                          <i className="ti ti-edit text-blue"></i> Edit
                                        </Link>
                                        <Link
                                          to="#"
                                          data-bs-toggle="modal"
                                          data-bs-target="#delete_task"
                                          className="dropdown-item"
                                          onClick={() => handleDeleteClickTask(task.id)}
                                        >
                                          <i className="ti ti-trash text-danger me-1" />
                                          Delete
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                  <p className="mb-1">{task.description || 'No description'}</p>
                                  <div className="d-flex flex-wrap gap-2 mb-1">
                                    <span className="badge bg-info">Status: {task.status}</span>
                                    <span className="badge bg-warning">Priority: {task.priority}</span>
                                    <span className="badge bg-secondary">Category: {task.category}</span>
                                  </div>
                                  <div className="d-flex justify-content-between align-items-center">
                                    <p className="mb-0 text-muted small">
                                      <i className="ti ti-calendar me-1"></i>
                                      Start: {new Date(task.startDate).toLocaleString()}
                                      {task.endDate ? ` | End: ${new Date(task.endDate).toLocaleString()}` : ' | No end date'}
                                    </p>
                                    <p className="mb-0 text-muted small">
                                      <i className="ti ti-user me-1"></i>
                                      {task.responsible.username || 'No responsible'}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="text-center p-3">
                          <div className="avatar avatar-lg bg-light-primary rounded-circle mb-2">
                            <i className="ti ti-list-check fs-24 text-primary"></i>
                          </div>
                          <h5>No tasks found</h5>
                          <p className="text-muted">Create a new task to get started</p>
                        </div>
                      )}
                    </div>
                    {/* /Recent Task List */}
                  </div>
                </div>
                {/* /Tasks */}
                {/* Files */}
                <div className="tab-pane fade" id="files">
                  <div className="card">
                    <div className="card-header">
                      <h4 className="fw-semibold">Files</h4>
                    </div>
                    <div className="card-body">
                      <div className="card border mb-3">
                        <div className="card-body pb-0">
                          <div className="row align-items-center">
                            <div className="col-md-8">
                              <div className="mb-3">
                                <h4 className="fw-medium mb-1">
                                  Manage Documents
                                </h4>
                                <p>
                                  Send customizable quotes, proposals and
                                  contracts to close deals faster.
                                </p>
                              </div>
                            </div>
                            <div className="col-md-4 text-md-end">
                              <div className="mb-3">
                                <Link
                                  to="#"
                                  className="btn btn-primary"
                                  data-bs-toggle="modal"
                                  data-bs-target="#new_file"
                                >
                                  Create Document
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card border shadow-none mb-3">
                        <div className="card-body pb-0">
                          <div className="row align-items-center">
                            <div className="col-md-8">
                              <div className="mb-3">
                                <h4 className="fw-medium mb-1">
                                  Collier-Turner Proposal
                                </h4>
                                <p>
                                  Send customizable quotes, proposals and
                                  contracts to close deals faster.
                                </p>
                                <div className="d-flex align-items-center">
                                  <span className="avatar avatar-md me-2 flex-shrink-0">
                                    <ImageWithBasePath
                                      src="assets/img/profiles/avatar-21.jpg"
                                      alt="img"
                                      className="rounded-circle"
                                    />
                                  </span>
                                  <div>
                                    <span className="fs-12">Owner</span>
                                    <p>Vaughan</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4 text-md-end">
                              <div className="mb-3 d-inline-flex align-items-center">
                                <span className="badge badge-danger-light me-1">
                                  Proposal
                                </span>
                                <span className="badge bg-pending priority-badge me-1">
                                  Draft
                                </span>
                                <div className="dropdown">
                                  <Link
                                    to="#"
                                    className="p-0 btn btn-icon btn-sm d-flex align-items-center justify-content-center"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    <i className="ti ti-dots-vertical" />
                                  </Link>
                                  <div className="dropdown-menu dropdown-menu-right">
                                    <Link className="dropdown-item" to="#">
                                      <i className="ti ti-edit text-blue me-1" />
                                      Edit
                                    </Link>
                                    <Link className="dropdown-item" to="#">
                                      <i className="ti ti-trash text-danger me-1" />
                                      Delete
                                    </Link>
                                    <Link className="dropdown-item" to="#">
                                      <i className="ti ti-download text-info me-1" />
                                      Download
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card border shadow-none mb-3">
                        <div className="card-body pb-0">
                          <div className="row align-items-center">
                            <div className="col-md-8">
                              <div className="mb-3">
                                <h4 className="fw-medium mb-1">
                                  Collier-Turner Proposal
                                </h4>
                                <p>
                                  Send customizable quotes, proposals and
                                  contracts to close deals faster.
                                </p>
                                <div className="d-flex align-items-center">
                                  <span className="avatar avatar-md me-2 flex-shrink-0">
                                    <ImageWithBasePath
                                      src="assets/img/profiles/avatar-01.jpg"
                                      alt="img"
                                      className="rounded-circle"
                                    />
                                  </span>
                                  <div>
                                    <span className="fs-12">Owner</span>
                                    <p>Jessica</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4 text-md-end">
                              <div className="mb-3 d-inline-flex align-items-center">
                                <span className="badge badge-purple-light me-1">
                                  Quote
                                </span>
                                <span className="badge bg-success me-1">
                                  Sent
                                </span>
                                <div className="dropdown">
                                  <Link
                                    to="#"
                                    className="p-0 btn btn-icon btn-sm d-flex align-items-center justify-content-center"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    <i className="ti ti-dots-vertical" />
                                  </Link>
                                  <div className="dropdown-menu dropdown-menu-right">
                                    <Link className="dropdown-item" to="#">
                                      <i className="ti ti-edit text-blue me-1" />
                                      Edit
                                    </Link>
                                    <Link className="dropdown-item" to="#">
                                      <i className="ti ti-trash text-danger me-1" />
                                      Delete
                                    </Link>
                                    <Link className="dropdown-item" to="#">
                                      <i className="ti ti-download text-info me-1" />
                                      Download
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card border shadow-none mb-0">
                        <div className="card-body pb-0">
                          <div className="row align-items-center">
                            <div className="col-md-8">
                              <div className="mb-3">
                                <h4 className="fw-medium mb-1">
                                  Collier-Turner Proposal
                                </h4>
                                <p>
                                  Send customizable quotes, proposals and
                                  contracts to close deals faster.
                                </p>
                                <div className="d-flex align-items-center">
                                  <span className="avatar avatar-md me-2 flex-shrink-0">
                                    <ImageWithBasePath
                                      src="assets/img/profiles/avatar-22.jpg"
                                      alt="img"
                                      className="rounded-circle"
                                    />
                                  </span>
                                  <div>
                                    <span className="fs-12">Owner</span>
                                    <p>Dawn Merhca</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4 text-md-end">
                              <div className="mb-3 d-inline-flex align-items-center">
                                <span className="badge badge-danger-light me-1">
                                  Proposal
                                </span>
                                <span className="badge bg-pending priority-badge me-1">
                                  Draft
                                </span>
                                <div className="dropdown">
                                  <Link
                                    to="#"
                                    className="p-0 btn btn-icon btn-sm d-flex align-items-center justify-content-center"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    <i className="ti ti-dots-vertical" />
                                  </Link>
                                  <div className="dropdown-menu dropdown-menu-right">
                                    <Link className="dropdown-item" to="#">
                                      <i className="ti ti-edit text-blue me-1" />
                                      Edit
                                    </Link>
                                    <Link className="dropdown-item" to="#">
                                      <i className="ti ti-trash text-danger me-1" />
                                      Delete
                                    </Link>
                                    <Link className="dropdown-item" to="#">
                                      <i className="ti ti-download text-info me-1" />
                                      Download
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Files */}
                {/* Email */}
                <div className="tab-pane fade" id="email">
                  <div className="card">
                    <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                      <h4 className="fw-semibold">Email</h4>
                      <div className="d-inline-flex align-items-center">
                        <OverlayTrigger
                          placement="left"
                          overlay={
                            <Tooltip id="refresh-tooltip">
                              Click here to send an email to this contact
                            </Tooltip>
                          }
                        >
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => setShowEmailModal(true)}
                          >
                            <i className="ti ti-mail me-2" />
                            Send Email
                          </button>
                        </OverlayTrigger>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="email-list">
                        {emailContactResponse.length > 0 ? (
                          emailContactResponse.map((email, index) => (
                            <div key={index} className="email-item mb-4">
                              {/* Email Header */}
                              <div className="email-header d-flex align-items-center justify-content-between p-3 bg-light rounded-top">
                                <div className="d-flex align-items-center">
                                  <div className="avatar avatar-sm bg-primary rounded-circle me-2">
                                    <i className="ti ti-mail fs-4"></i>
                                  </div>
                                  <div>
                                    <h6 className="mb-0 fw-semibold">{email.subject}</h6>
                                    <small className="text-muted">
                                      From: {email.createdBy} • {new Date(email.createdAt).toLocaleString()}
                                    </small>
                                  </div>
                                </div>
                              </div>

                              {/* Email Body */}
                              <div className="email-body p-3 border rounded-bottom">
                                <div className="email-content mb-3">
                                  {email.body}
                                </div>

                                {/* Replies Section */}
                                {email.childEmailLogs && email.childEmailLogs.length > 0 && (
                                  <div className="replies-section mt-3">
                                    <div className="d-flex align-items-center mb-2">
                                      <div className="border-start border-primary border-3 ps-2">
                                        <h6 className="mb-0 fw-semibold">Replies</h6>
                                      </div>
                                    </div>
                                    {email.childEmailLogs.map((childEmail, idx) => (
                                      <div key={idx} className="reply-item p-3 bg-light rounded mb-2">
                                        <div className="d-flex align-items-center mb-2">
                                          <div className="avatar avatar-xs bg-secondary rounded-circle me-2">
                                            <i className="ti ti-mail fs-4"></i>
                                          </div>
                                          <div>
                                            <h6 className="mb-0 fw-semibold">{childEmail.subject}</h6>
                                          </div>
                                        </div>
                                        <div className="reply-content">
                                          {childEmail.body}
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="text-center py-5">
                            <div className="avatar avatar-lg bg-light-primary rounded-circle mb-3">
                              <i className="ti ti-mail fs-4"></i>
                            </div>
                            <h6 className="mb-2">No Emails Yet</h6>
                            <p className="text-muted mb-0">Start a conversation with this contact</p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Email */}
              </div>
              {/* /Tab Content */}
            </div>
            {/* /Contact Details */}
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
      {/* Delete Contact */}
      <Modal show={openModal} onHide={() => setOpenModal(false)}>
        <div className="modal-body">
          <div className="text-center">
            <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
              <i className="ti ti-trash-x fs-36 text-danger" />
            </div>
            <h4 className="mb-2">Remove Contacts?</h4>
            <p className="mb-0">
              Are you sure you want to remove <br /> contact you selected.
            </p>
            <div className="d-flex align-items-center justify-content-center mt-4">
              <Link
                to="#"
                className="btn btn-light me-2"
                data-bs-dismiss="modal"
              >
                Cancel
              </Link>
              <Link to={route.contactList} className="btn btn-danger">
                Yes, Delete it
              </Link>
            </div>
          </div>
        </div>
      </Modal>
      {/* /Delete Contact */}
      {/* Create Deal */}
      <div
        className="modal custom-modal fade"
        id="create_success"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0 m-0 justify-content-end">
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <div className="success-message text-center">
                <div className="success-popup-icon bg-light-blue">
                  <i className="ti ti-building" />
                </div>
                <h3>Deal Created Successfully!!!</h3>
                <p>View the details of deal, created</p>
                <div className="col-lg-12 text-center modal-btn">
                  <Link
                    to="#"
                    className="btn btn-light"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <Link
                    to={route.contactDetails}
                    data-bs-dismiss="modal"
                    className="btn btn-primary"
                  >
                    View Details
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Create Deal */}
      {/* Add Note */}
      <div
        className="modal custom-modal fade modal-padding"
        id="add_notes"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add New Notes</h5>
              <button
                type="button"
                className="btn-close position-static"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form action={route.contactDetails}>
                <div className="mb-3">
                  <label className="col-form-label">
                    Title <span className="text-danger"> *</span>
                  </label>
                  <input className="form-control" type="text" />
                </div>
                <div className="mb-3">
                  <label className="col-form-label">
                    Note <span className="text-danger"> *</span>
                  </label>
                  <textarea
                    className="form-control"
                    rows={4}
                    defaultValue={""}
                  />
                </div>
                <div className="mb-3">
                  <label className="col-form-label">
                    Attachment <span className="text-danger"> *</span>
                  </label>
                  <div className="drag-attach">
                    <input type="file" />
                    <div className="img-upload">
                      <i className="ti ti-file-broken" />
                      Upload File
                    </div>
                  </div>
                </div>
                <div className="mb-3">
                  <label className="col-form-label">Uploaded Files</label>
                  <div className="upload-file">
                    <h6>Projectneonals teyys.xls</h6>
                    <p>4.25 MB</p>
                    <div className="progress">
                      <div
                        className="progress-bar bg-success"
                        role="progressbar"
                        style={{ width: "25%" }}
                        aria-valuenow={25}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      />
                    </div>
                    <p className="black-text">45%</p>
                  </div>
                  <div className="upload-file upload-list">
                    <div>
                      <h6>tes.txt</h6>
                      <p>4.25 MB</p>
                    </div>
                    <Link to="#" className="text-danger">
                      <i className="ti ti-trash-x" />
                    </Link>
                  </div>
                </div>
                <div className="col-lg-12 text-end modal-btn">
                  <Link
                    to="#"
                    className="btn btn-light"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <button className="btn btn-primary" type="submit">
                    Confirm
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Note */}
      {/* Create Call Log */}
      <div
        className="modal custom-modal fade modal-padding"
        id="create_call"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Create Call Log</h5>
              <button
                type="button"
                className="btn-close position-static"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="col-form-label">
                        User Call <span className="text-danger"> *</span>
                      </label>
                      {loading ? (
                        <div>Loading...</div>
                      ) : error ? (
                        <div className="text-danger">{error}</div>
                      ) : (
                        <select
                          className="form-control"
                          value={newLogCall.userCall}
                          disabled={true}
                          onChange={(e) => setNewLogCall(prev => ({ ...prev, userCall: e.target.value }))}
                        >
                          <option value="" disabled>
                            Select User Call
                          </option>
                          {listUserCall.length > 0 ? (
                            listUserCall.map((user) => (
                              <option key={user.uuid} value={user.uuid}>
                                {user.username}
                              </option>
                            ))
                          ) : (
                            <option value="">No users available</option>
                          )}
                        </select>
                      )}
                    </div>
                    <div className="mb-3">
                      <label className="col-form-label">
                        Status <span className="text-danger"> *</span>
                      </label>
                      <Select
                        className="select2"
                        options={statusList}
                        placeholder="Choose"
                        classNamePrefix="react-select"
                        onChange={(selected) => {
                          if (selected) {
                            setNewLogCall((prev) => ({ ...prev, status: selected.value }));
                          }
                        }}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="col-form-label">
                        Follow Up Date <span className="text-danger"> *</span>
                      </label>
                      <input
                        type="datetime-local"
                        className="form-control"
                        value={newLogCall.followUpDate}
                        onChange={(e) => setNewLogCall(prev => ({ ...prev, followUpDate: e.target.value }))}
                      />
                    </div>
                    <div className="row">
                      {/* Assign Type */}
                      <div className="col-md-6">
                        <label className="col-form-label">Assign Type</label>
                        <select
                          className="form-control"
                          value={newTaskData.assignType}
                          disabled={true}
                          onChange={handleTaskAssignTypeChange}>
                          <option value="">Select Assign Type</option>
                          {selectAssignType.map((option) => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </div>

                      {/* Assign */}
                      <div className="col-md-6">
                        <label className="col-form-label">Assign</label>
                        <Select
                          className="select2"
                          options={assignTaskOptions}
                          placeholder="Choose"
                          classNamePrefix="react-select"
                          value={assignTaskOptions.find(option => option.value === newLogCall.assignRecord) || null}
                          onChange={(selectedOption) => setNewLogCall({ ...newLogCall, assignRecord: selectedOption?.value || 0 })}
                          isDisabled={true}
                        />
                      </div>
                    </div>

                    {/* Target Type */}
                    <div className="row">
                      <div className="col-md-6">
                        <label className="col-form-label">Target Type</label>
                        <select
                          className="form-control"
                          value={newLogCall.targetType}
                          onChange={handleTaskRelatedToTypeChange}
                        >
                          <option value="">Select Target Type</option>
                          {selectRelatedToType.map((option) => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </div>

                      {/* Target */}
                      <div className="col-md-6">
                        <label className="col-form-label">Target</label>
                        <Select
                          className="select2"
                          options={relateTaskOptions}
                          placeholder="Choose"
                          classNamePrefix="react-select"
                          value={relateTaskOptions.find(option => option.value === newLogCall.targetRecord) || null}
                          onChange={(selectedOption) => setNewLogCall({ ...newLogCall, targetRecord: selectedOption?.value || 0 })}
                          isDisabled={relateTaskOptions.length === 0}
                        />
                      </div>
                    </div>
                    <div className="mb-3">
                      <label className="col-form-label">
                        Note <span className="text-danger"> *</span>
                      </label>
                      <textarea
                        className="form-control"
                        rows={4}
                        placeholder="Add text"
                        value={newLogCall.note}
                        onChange={(e) => setNewLogCall(prev => ({ ...prev, note: e.target.value }))}
                      />
                    </div>

                    <div className="mb-3">
                      <label className="checkboxs">
                        <input
                          type="checkbox"
                          checked={newLogCall.checkedCreateFollowingTask}
                          onChange={(e) => setNewLogCall(prev => ({ ...prev, checkedCreateFollowingTask: e.target.checked }))}
                        />
                        <span className="checkmarks" /> Create a Follow-Up task
                      </label>
                    </div>

                    <div className="text-end modal-btn">
                      <Link
                        to="#"
                        className="btn btn-light"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </Link>
                      <button className="btn btn-primary" data-bs-dismiss="modal" type="button"
                        onClick={handleCreateLogCall}
                      >
                        Confirm
                      </button>
                    </div>

                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Create Call Log */}
      {/* Add File */}
      <div
        className="modal custom-modal fade custom-modal-two modal-padding"
        id="new_file"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Create New File</h5>
              <button
                type="button"
                className="btn-close position-static"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="add-info-fieldset">
                <div className="add-details-wizard">
                  <ul className="progress-bar-wizard">
                    <li className="active">
                      <span>
                        <i className="ti ti-file" />
                      </span>
                      <div className="multi-step-info">
                        <h6>Basic Info</h6>
                      </div>
                    </li>
                    <li>
                      <span>
                        <i className="ti ti-circle-plus" />
                      </span>
                      <div className="multi-step-info">
                        <h6>Add Recipient</h6>
                      </div>
                    </li>
                  </ul>
                </div>
                <fieldset id="first-field-file">
                  <form action={route.contactDetails}>
                    <div className="contact-input-set">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Choose Deal <span className="text-danger">*</span>
                            </label>
                            <Select
                              className="select2"
                              options={dealsopen}
                              placeholder="Choose"
                              classNamePrefix="react-select"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Document Type{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <Select
                              className="select2"
                              options={documentType}
                              placeholder="Choose"
                              classNamePrefix="react-select"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Owner <span className="text-danger">*</span>
                            </label>
                            <SelectWithImage2 />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Title <span className="text-danger"> *</span>
                            </label>
                            <input className="form-control" type="text" />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Locale <span className="text-danger">*</span>
                            </label>
                            <Select
                              className="select2"
                              options={LocaleData}
                              placeholder="Choose"
                              classNamePrefix="react-select"
                            />
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="signature-wrap">
                            <h4>Signature</h4>
                            <ul className="nav sign-item">
                              <li className="nav-item">
                                <span
                                  className=" mb-0"
                                  data-bs-toggle="tab"
                                  data-bs-target="#nosign"
                                >
                                  <input
                                    type="radio"
                                    className="status-radio"
                                    id="sign1"
                                    name="email"
                                  />
                                  <label htmlFor="sign1">
                                    <span className="sign-title">
                                      No Signature
                                    </span>
                                    This document does not require a signature
                                    before acceptance.
                                  </label>
                                </span>
                              </li>
                              <li className="nav-item">
                                <span
                                  className="active mb-0"
                                  data-bs-toggle="tab"
                                  data-bs-target="#use-esign"
                                >
                                  <input
                                    type="radio"
                                    className="status-radio"
                                    id="sign2"
                                    name="email"
                                    defaultChecked
                                  />
                                  <label htmlFor="sign2">
                                    <span className="sign-title">
                                      Use e-signature
                                    </span>
                                    This document require e-signature before
                                    acceptance.
                                  </label>
                                </span>
                              </li>
                            </ul>
                            <div className="tab-content">
                              <div
                                className="tab-pane show active"
                                id="use-esign"
                              >
                                <div className="input-block mb-0">
                                  <label className="col-form-label">
                                    Document Signers{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                                <div className="sign-content">
                                  <div className="row">
                                    <div className="col-md-6">
                                      <div className="mb-3">
                                        <input
                                          className="form-control"
                                          type="text"
                                          placeholder="Enter Name"
                                        />
                                      </div>
                                    </div>
                                    <div className="col-md-6">
                                      <div className="d-flex align-items-center">
                                        <div className="float-none mb-3 me-3 w-100">
                                          <input
                                            className="form-control"
                                            type="text"
                                            placeholder="Email Address"
                                          />
                                        </div>
                                        <div className="input-btn mb-3">
                                          <Link to="#" className="add-sign">
                                            <i className="ti ti-circle-plus" />
                                          </Link>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="input-block mb-3">
                            <label className="col-form-label">
                              Content <span className="text-danger"> *</span>
                            </label>
                            <textarea
                              className="form-control"
                              rows={3}
                              placeholder="Add Content"
                              defaultValue={""}
                            />
                          </div>
                        </div>
                        <div className="col-lg-12 text-end form-wizard-button modal-btn">
                          <button className="btn btn-light" type="reset">
                            Reset
                          </button>
                          <button
                            className="btn btn-primary wizard-next-btn"
                            type="button"
                          >
                            Next
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </fieldset>
                <fieldset>
                  <form action={route.contactDetails}>
                    <div className="contact-input-set">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="signature-wrap">
                            <h4 className="mb-2">
                              Send the document to following signers
                            </h4>
                            <p>In order to send the document to the signers</p>
                            <div className="input-block mb-0">
                              <label className="col-form-label">
                                Recipients (Additional recipients)
                              </label>
                            </div>
                            <div className="sign-content">
                              <div className="row">
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <input
                                      className="form-control"
                                      type="text"
                                      placeholder="Enter Name"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="d-flex align-items-center">
                                    <div className="float-none mb-3 me-3 w-100">
                                      <input
                                        className="form-control"
                                        type="text"
                                        placeholder="Email Address"
                                      />
                                    </div>
                                    <div className="input-btn mb-3">
                                      <Link to="#" className="add-sign">
                                        <i className="ti ti-circle-plus" />
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Message Subject{" "}
                              <span className="text-danger"> *</span>
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              placeholder="Enter Subject"
                            />
                          </div>
                          <div className="mb-3">
                            <label className="col-form-label">
                              Message Text{" "}
                              <span className="text-danger"> *</span>
                            </label>
                            <textarea
                              className="form-control"
                              rows={3}
                              placeholder="Your document is ready"
                              defaultValue={""}
                            />
                          </div>
                          <button className="btn btn-light mb-3">
                            Send Now
                          </button>
                          <div className="send-success">
                            <p>
                              <i className="ti ti-circle-check" /> Document sent
                              successfully to the selected recipients
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-12 text-end form-wizard-button modal-btn">
                          <button className="btn btn-light" type="reset">
                            Cancel
                          </button>
                          <button
                            className="btn btn-primary"
                            type="button"
                            data-bs-dismiss="modal"
                          >
                            Save &amp; Next
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </fieldset>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Add File */}
      {/* Connect Account */}
      <div className="modal custom-modal fade" id="create_email" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Connect Account</h5>
              <button
                type="button"
                className="btn-close position-static"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label className="col-form-label">
                  Account type <span className="text-danger"> *</span>
                </label>
                <Select
                  className="select2"
                  options={accountType}
                  placeholder="Choose"
                  classNamePrefix="react-select"
                />
              </div>
              <div className="mb-3">
                <h5 className="form-title">Sync emails from</h5>
                <div className="sync-radio">
                  <div className="radio-item">
                    <input
                      type="radio"
                      className="status-radio"
                      id="test1"
                      name="radio-group"
                      defaultChecked
                    />
                    <label htmlFor="test1">Now</label>
                  </div>
                  <div className="radio-item">
                    <input
                      type="radio"
                      className="status-radio"
                      id="test2"
                      name="radio-group"
                    />
                    <label htmlFor="test2">1 Month Ago</label>
                  </div>
                  <div className="radio-item">
                    <input
                      type="radio"
                      className="status-radio"
                      id="test3"
                      name="radio-group"
                    />
                    <label htmlFor="test3">3 Month Ago</label>
                  </div>
                  <div className="radio-item">
                    <input
                      type="radio"
                      className="status-radio"
                      id="test4"
                      name="radio-group"
                    />
                    <label htmlFor="test4">6 Month Ago</label>
                  </div>
                </div>
              </div>
              <div className="col-lg-12 text-end modal-btn">
                <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                  Cancel
                </Link>
                <button
                  className="btn btn-primary"
                  data-bs-target="#success_mail"
                  data-bs-toggle="modal"
                  data-bs-dismiss="modal"
                >
                  Connect Account
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Connect Account */}
      {/* Success Contact */}
      <div className="modal custom-modal fade" id="success_mail" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0 m-0 justify-content-end">
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <div className="success-message text-center">
                <div className="success-popup-icon bg-light-blue">
                  <i className="ti ti-mail-opened" />
                </div>
                <h3>Email Connected Successfully!!!</h3>
                <p>
                  Email Account is configured with "example@example.com". Now
                  you can access email.
                </p>
                <div className="col-lg-12 text-center modal-btn">
                  <Link to={route.contactDetails} className="btn btn-primary">
                    Go to email
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Success Contact */}
      {/* Access */}
      <div className="modal custom-modal fade" id="access_view" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Access For</h5>
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <form action={route.contactDetails}>
                <div className="mb-2 icon-form">
                  <span className="form-icon">
                    <i className="ti ti-search" />
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                  />
                </div>
                <div className="access-wrap">
                  <ul>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar-19.jpg"
                            alt=""
                          />
                          <Link to="#">Darlee Robertson</Link>
                        </span>
                      </label>
                    </li>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar-20.jpg"
                            alt=""
                          />
                          <Link to="#">Sharon Roy</Link>
                        </span>
                      </label>
                    </li>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar-21.jpg"
                            alt=""
                          />
                          <Link to="#">Vaughan</Link>
                        </span>
                      </label>
                    </li>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar-01.jpg"
                            alt=""
                          />
                          <Link to="#">Jessica</Link>
                        </span>
                      </label>
                    </li>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar-16.jpg"
                            alt=""
                          />
                          <Link to="#">Carol Thomas</Link>
                        </span>
                      </label>
                    </li>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar-22.jpg"
                            alt=""
                          />
                          <Link to="#">Dawn Mercha</Link>
                        </span>
                      </label>
                    </li>
                  </ul>
                </div>
                <div className="modal-btn text-end">
                  <Link
                    to="#"
                    className="btn btn-light"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <button type="submit" className="btn btn-primary">
                    Confirm
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Access */}
      {/* Add Compose */}
      <div className="modal custom-modal fade" id="add_compose" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Compose</h5>
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <form action="#">
                <div className="mb-3">
                  <input
                    type="email"
                    placeholder="To"
                    className="form-control"
                  />
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-3">
                      <input
                        type="email"
                        placeholder="Cc"
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <input
                        type="email"
                        placeholder="Bcc"
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>
                <div className="mb-3">
                  <input
                    type="text"
                    placeholder="Subject"
                    className="form-control"
                  />
                </div>
                <div className="mb-3">
                  <DefaultEditor className="summernote" />
                </div>
                <div className="mb-3">
                  <div className="text-center">
                    <button className="btn btn-primary">
                      <span>Send</span>
                      <i className="fa-solid fa-paper-plane ms-1" />
                    </button>
                    <button className="btn btn-primary ms-1" type="button">
                      <span>Draft</span>{" "}
                      <i className="fa-regular fa-floppy-disk ms-1" />
                    </button>
                    <button className="btn btn-primary ms-1" type="button">
                      <span>Delete</span>{" "}
                      <i className="fa-regular fa-trash-can ms-1" />
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Compose */}
      {/* Edit Contact */}
      <div
        className="offcanvas offcanvas-end offcanvas-large"
        tabIndex={-1}
        id="offcanvas_edit"
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="fw-semibold">Edit Contact</h5>
          <button
            type="button"
            className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="offcanvas-body">
          <form>
            <div className="accordion" id="main_accordion_2">
              {/* Basic Info */}
              <div className="accordion-item rounded mb-3">
                <div className="accordion-header">
                  <Link
                    to="#"
                    className="accordion-button accordion-custom-button bg-white rounded fw-medium text-dark"
                    data-bs-toggle="collapse"
                    data-bs-target="#basic-2"
                  >
                    <span className="avatar avatar-md rounded text-dark border me-2">
                      <i className="ti ti-user-plus fs-20" />
                    </span>
                    Basic Info
                  </Link>
                </div>
                <div
                  className="accordion-collapse collapse show"
                  id="basic-2"
                  data-bs-parent="#main_accordion_2"
                >
                  <div className="accordion-body border-top">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-3">
                          <div className="profile-upload">
                            <div className="profile-upload-img">
                              <span>
                                <i className="ti ti-photo" />
                              </span>
                              <ImageWithBasePath
                                src="assets/img/profiles/avatar-20.jpg"
                                alt="img"
                                className="preview1"
                              />
                              <button type="button" className="profile-remove">
                                <i className="ti ti-x" />
                              </button>
                            </div>
                            <div className="profile-upload-content">
                              <label className="profile-upload-btn">
                                <i className="ti ti-file-broken" /> Upload File
                                <input type="file" className="input-img" />
                              </label>
                              <p>JPG, GIF or PNG. Max size of 800K</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            First Name <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            defaultValue="Darlee"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Last Name <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            defaultValue="Robertson"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Job Title <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            defaultValue="Facility Manager"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Company Name</label>
                          <Select
                            className="select2"
                            classNamePrefix="react-select"
                            options={companyName}
                            defaultValue={companyName[1]}
                            placeholder="Choose"
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="mb-3">
                          <div className="d-flex justify-content-between align-items-center">
                            <label className="col-form-label">
                              Email <span className="text-danger">*</span>
                            </label>
                            <div className="status-toggle small-toggle-btn d-flex align-items-center">
                              <span className="me-2 label-text">
                                Email Opt Out
                              </span>
                              <input
                                type="checkbox"
                                id="user2"
                                className="check"
                                defaultChecked
                                defaultValue="robertson@example.com"
                              />
                              <label htmlFor="user2" className="checktoggle" />
                            </div>
                          </div>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Phone 1 <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            defaultValue={6234567890}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Phone 2</label>
                          <input
                            type="text"
                            className="form-control"
                            defaultValue={7234567899}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Fax <span className="text-danger">*</span>
                          </label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <div className="d-flex align-items-center justify-content-between">
                            <label className="col-form-label">Deals</label>
                            <Link
                              to="#"
                              className="label-add"
                              data-bs-toggle="offcanvas"
                              data-bs-target="#offcanvas_add_2"
                            >
                              <i className="ti ti-square-rounded-plus" />
                              Add New
                            </Link>
                          </div>
                          <Select
                            className="select2"
                            classNamePrefix="react-select"
                            options={dealsopen}
                            defaultValue={dealsopen[2]}
                            placeholder="Choose"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Date of Birth
                          </label>
                          <div className="icon-form-end">
                            <span className="form-icon">
                              <i className="ti ti-calendar-event" />
                            </span>
                            <DatePicker
                              className="form-control datetimepicker deals-details"
                              selected={selectedDate}
                              onChange={handleDateChange}
                              dateFormat="dd-MM-yyyy"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Reviews </label>
                          <div className="icon-form-end">
                            <span className="form-icon">
                              <i className="ti ti-star" />
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="4.2"
                              defaultValue="4.2"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="fmb-3">
                          <label className="col-form-label">Owner</label>
                          <SelectWithImage />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Tags </label>
                          <TagsInput value={owner} onChange={setOwner} />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Source <span className="text-danger">*</span>
                          </label>
                          <Select
                            className="select2"
                            classNamePrefix="react-select"
                            options={activities}
                            placeholder="Select an option"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Industry <span className="text-danger">*</span>
                          </label>
                          <Select
                            className="select"
                            classNamePrefix="react-select"
                            options={industries}
                            placeholder="Banking"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Currency <span className="text-danger">*</span>
                          </label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Language <span className="text-danger">*</span>
                          </label>
                          <Select
                            className="select"
                            classNamePrefix="react-select"
                            options={languages}
                            placeholder="English"
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="mb-0">
                          <label className="col-form-label">
                            Description <span className="text-danger">*</span>
                          </label>
                          <textarea
                            className="form-control"
                            rows={5}
                            defaultValue={""}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Basic Info */}
              {/* Address Info */}
              <div className="accordion-item border-top rounded mb-3">
                <div className="accordion-header">
                  <Link
                    to="#"
                    className="accordion-button accordion-custom-button rounded bg-white fw-medium text-dark"
                    data-bs-toggle="collapse"
                    data-bs-target="#address-2"
                  >
                    <span className="avatar avatar-md rounded text-dark border me-2">
                      <i className="ti ti-map-pin-cog fs-20" />
                    </span>
                    Address Info
                  </Link>
                </div>
                <div
                  className="accordion-collapse collapse"
                  id="address-2"
                  data-bs-parent="#main_accordion_2"
                >
                  <div className="accordion-body border-top">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Street Address{" "}
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            defaultValue="22, Ave Street"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">City </label>
                          <input
                            type="text"
                            className="form-control"
                            defaultValue="Denver"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            State / Province{" "}
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            defaultValue="Colorado"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3 mb-md-0">
                          <label className="col-form-label">Country</label>
                          <Select
                            className="select"
                            classNamePrefix="react-select"
                            options={countries}
                            defaultValue={countries[2]}
                            placeholder="Choose"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-0">
                          <label className="col-form-label">Zipcode </label>
                          <input
                            type="text"
                            className="form-control"
                            defaultValue={546}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Address Info */}
              {/* Social Profile */}
              <div className="accordion-item border-top rounded mb-3">
                <div className="accordion-header">
                  <Link
                    to="#"
                    className="accordion-button accordion-custom-button rounded bg-white fw-medium text-dark"
                    data-bs-toggle="collapse"
                    data-bs-target="#social-2"
                  >
                    <span className="avatar avatar-md rounded text-dark border me-2">
                      <i className="ti ti-social fs-20" />
                    </span>
                    Social Profile
                  </Link>
                </div>
                <div
                  className="accordion-collapse collapse"
                  id="social-2"
                  data-bs-parent="#main_accordion_2"
                >
                  <div className="accordion-body border-top">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Facebook</label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Skype </label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Linkedin </label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Twitter</label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3 mb-md-0">
                          <label className="col-form-label">Whatsapp</label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-0">
                          <label className="col-form-label">Instagram</label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Social Profile */}
              {/* Access */}
              <div className="accordion-item border-top rounded mb-3">
                <div className="accordion-header">
                  <Link
                    to="#"
                    className="accordion-button accordion-custom-button rounded bg-white fw-medium text-dark"
                    data-bs-toggle="collapse"
                    data-bs-target="#access-info-2"
                  >
                    <span className="avatar avatar-md rounded text-dark border me-2">
                      <i className="ti ti-accessible fs-20" />
                    </span>
                    Access
                  </Link>
                </div>
                <div
                  className="accordion-collapse collapse"
                  id="access-info-2"
                  data-bs-parent="#main_accordion_2"
                >
                  <div className="accordion-body border-top">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="col-form-label">Visibility</label>
                          <div className="d-flex flex-wrap">
                            <div className="me-2">
                              <input
                                type="radio"
                                className="status-radio"
                                id="public2"
                                name="visible"
                              />
                              <label htmlFor="public2">Public</label>
                            </div>
                            <div className="me-2">
                              <input
                                type="radio"
                                className="status-radio"
                                id="private2"
                                name="visible"
                              />
                              <label htmlFor="private2">Private</label>
                            </div>
                            <div
                              data-bs-toggle="modal"
                              data-bs-target="#access_view"
                            >
                              <input
                                type="radio"
                                className="status-radio"
                                id="people2"
                                name="visible"
                              />
                              <label htmlFor="people2">Select People</label>
                            </div>
                          </div>
                        </div>
                        <div className="mb-0">
                          <label className="col-form-label">Status</label>
                          <div className="d-flex flex-wrap">
                            <div className="me-2">
                              <input
                                type="radio"
                                className="status-radio"
                                id="active2"
                                name="status"
                                defaultChecked
                              />
                              <label htmlFor="active2">Active</label>
                            </div>
                            <div>
                              <input
                                type="radio"
                                className="status-radio"
                                id="inactive2"
                                name="status"
                              />
                              <label htmlFor="inactive2">Inactive</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Access */}
            </div>
            <div className="d-flex align-items-center justify-content-end">
              <button
                type="button"
                data-bs-dismiss="offcanvas"
                className="btn btn-light me-2"
              >
                Cancel
              </button>
              <button type="button" className="btn btn-primary">
                Save Changes
              </button>
            </div>
          </form>
        </div>
      </div>
      {/* /Edit Contact */}
      {/* Add New Deals */}
      <div
        className="offcanvas offcanvas-end offcanvas-large"
        tabIndex={-1}
        id="offcanvas_add_2"
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="fw-semibold">Add New Deals</h5>
          <button
            type="button"
            className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="offcanvas-body">
          <form>
            <div className="row">
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="col-form-label">
                    Deal Name <span className="text-danger">*</span>
                  </label>
                  <input type="text" className="form-control" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <div className="d-flex align-items-center justify-content-between">
                    <label className="col-form-label">
                      Pipeine <span className="text-danger">*</span>
                    </label>
                  </div>
                  <Select
                    className="select2"
                    options={salestypelist}
                    placeholder="Choose"
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Status <span className="text-danger">*</span>
                  </label>
                  <Select
                    className="select2"
                    options={status}
                    placeholder="Choose"
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Deal Value<span className="text-danger"> *</span>
                  </label>
                  <input className="form-control" type="text" />
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Currency <span className="text-danger">*</span>
                  </label>
                  <Select
                    className="select2"
                    options={optionssymbol}
                    placeholder="Choose"
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Period <span className="text-danger">*</span>
                  </label>
                  <Select
                    className="select2"
                    options={duration}
                    placeholder="Choose"
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Period Value <span className="text-danger">*</span>
                  </label>
                  <input className="form-control" type="text" />
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="col-form-label">
                    Contact <span className="text-danger">*</span>
                  </label>
                  <SelectWithImage2 />
                </div>
                <div className="mb-3">
                  <label className="col-form-label">
                    Project <span className="text-danger">*</span>
                  </label>
                  <Select
                    className="select2"
                    options={project}
                    defaultValue={tagInputValues}
                    isMulti
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Due Date <span className="text-danger">*</span>
                  </label>
                  <div className="icon-form">
                    <span className="form-icon">
                      <i className="ti ti-calendar-check" />
                    </span>
                    <DatePicker
                      className="form-control datetimepicker deals-details"
                      selected={selectedDate}
                      onChange={handleDateChange}
                      dateFormat="dd-MM-yyyy"
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Expected Closing Date <span className="text-danger">*</span>
                  </label>
                  <div className="icon-form">
                    <span className="form-icon">
                      <i className="ti ti-calendar-check" />
                    </span>

                    <DatePicker
                      className="form-control datetimepicker deals-details"
                      selected={selectedDate1}
                      onChange={handleDateChange1}
                      dateFormat="dd-MM-yyyy"
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="col-form-label">
                    Assignee <span className="text-danger">*</span>
                  </label>
                  <SelectWithImage2 />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Follow Up Date <span className="text-danger">*</span>
                  </label>
                  <div className="icon-form">
                    <span className="form-icon">
                      <i className="ti ti-calendar-check" />
                    </span>
                    <DatePicker
                      className="form-control datetimepicker deals-details"
                      selected={selectedDate}
                      onChange={handleDateChange}
                      dateFormat="dd-MM-yyyy"
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Source <span className="text-danger">*</span>
                  </label>

                  <Select
                    className="select2"
                    options={socialMedia}
                    placeholder="Choose"
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Tags <span className="text-danger">*</span>
                  </label>
                  <TagsInput
                    // className="input-tags form-control"
                    value={owner}
                    onChange={setOwner}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Priority <span className="text-danger">*</span>
                  </label>
                  <Select
                    className="select2"
                    options={priorityList}
                    placeholder="Choose"
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="mb-3">
                  <label className="col-form-label">
                    Description <span className="text-danger">*</span>
                  </label>
                  <DefaultEditor className="summernote" />
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-end">
              <button
                type="button"
                data-bs-dismiss="offcanvas"
                className="btn btn-light me-2"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => setOpenModal(true)}
              >
                Create
              </button>
            </div>
          </form>
        </div>
      </div>
      {/* /Add New Deals */}
      {/* Add Company */}
      <div
        className="offcanvas offcanvas-end offcanvas-large"
        tabIndex={-1}
        id="offcanvas_add"
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="fw-semibold">Add New Company</h5>
          <button
            type="button"
            className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="offcanvas-body">
          <form>
            <div className="accordion" id="main_accordion">
              {/* Basic Info */}
              <div className="accordion-item rounded mb-3">
                <div className="accordion-header">
                  <Link
                    to="#"
                    className="accordion-button accordion-custom-button bg-white rounded fw-medium text-dark"
                    data-bs-toggle="collapse"
                    data-bs-target="#basic"
                  >
                    <span className="avatar avatar-md rounded text-dark border me-2">
                      <i className="ti ti-user-plus fs-20" />
                    </span>
                    Basic Info
                  </Link>
                </div>
                <div
                  className="accordion-collapse collapse show"
                  id="basic"
                  data-bs-parent="#main_accordion"
                >
                  <div className="accordion-body border-top">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-3">
                          <div className="profile-upload">
                            <div className="profile-upload-img">
                              <span>
                                <i className="ti ti-photo" />
                              </span>
                              <ImageWithBasePath
                                src="assets/img/profiles/avatar-20.jpg"
                                alt="img"
                                className="preview1"
                              />
                              <button type="button" className="profile-remove">
                                <i className="ti ti-x" />
                              </button>
                            </div>
                            <div className="profile-upload-content">
                              <label className="profile-upload-btn">
                                <i className="ti ti-file-broken" /> Upload File
                                <input type="file" className="input-img" />
                              </label>
                              <p>JPG, GIF or PNG. Max size of 800K</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="col-form-label">Company Name</label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="mb-3">
                          <div className="d-flex justify-content-between align-items-center">
                            <label className="col-form-label">
                              Email <span className="text-danger">*</span>
                            </label>
                            <div className="status-toggle small-toggle-btn d-flex align-items-center">
                              <span className="me-2 label-text">
                                Email Opt Out
                              </span>
                              <input
                                type="checkbox"
                                id="user"
                                className="check"
                                defaultChecked
                              />
                              <label htmlFor="user" className="checktoggle" />
                            </div>
                          </div>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Phone 1 <span className="text-danger">*</span>
                          </label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Phone 2</label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Fax <span className="text-danger">*</span>
                          </label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Website <span className="text-danger">*</span>
                          </label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Ratings</label>
                          <div className="icon-form-end">
                            <span className="form-icon">
                              <i className="ti ti-star" />
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="4.2"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="fmb-3">
                          <label className="col-form-label">Owner</label>
                          <SelectWithImage2 />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Tags </label>
                          <input
                            className="input-tags form-control"
                            type="text"
                            data-role="tagsinput"
                            name="Label"
                            defaultValue="Collab"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <div className="d-flex align-items-center justify-content-between">
                            <label className="col-form-label">Deals</label>
                            <Link
                              to="#"
                              className="label-add"
                              data-bs-toggle="offcanvas"
                              data-bs-target="#offcanvas_add_2"
                            >
                              <i className="ti ti-square-rounded-plus" />
                              Add New
                            </Link>
                          </div>
                          <Select
                            className="select2"
                            classNamePrefix="react-select"
                            options={dealsopen}
                            placeholder="Choose"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Source <span className="text-danger">*</span>
                          </label>
                          <Select
                            className="select2"
                            classNamePrefix="react-select"
                            options={activities}
                            placeholder="Choose"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Industry <span className="text-danger">*</span>
                          </label>
                          <Select
                            className="select2"
                            classNamePrefix="react-select"
                            options={industries}
                            placeholder="Choose"
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="col-form-label">Contacts</label>
                          <Select
                            className="select2"
                            options={project}
                            defaultValue={tagInputValues}
                            isMulti
                            classNamePrefix="react-select"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Currency <span className="text-danger">*</span>
                          </label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Language <span className="text-danger">*</span>
                          </label>
                          <Select
                            className="select2"
                            classNamePrefix="react-select"
                            options={languages}
                            placeholder="Choose"
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="mb-0">
                          <label className="col-form-label">
                            Description <span className="text-danger">*</span>
                          </label>
                          <textarea
                            className="form-control"
                            rows={5}
                            defaultValue={""}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Basic Info */}
              {/* Address Info */}
              <div className="accordion-item border-top rounded mb-3">
                <div className="accordion-header">
                  <Link
                    to="#"
                    className="accordion-button accordion-custom-button rounded bg-white fw-medium text-dark"
                    data-bs-toggle="collapse"
                    data-bs-target="#address"
                  >
                    <span className="avatar avatar-md rounded text-dark border me-2">
                      <i className="ti ti-map-pin-cog fs-20" />
                    </span>
                    Address Info
                  </Link>
                </div>
                <div
                  className="accordion-collapse collapse"
                  id="address"
                  data-bs-parent="#main_accordion"
                >
                  <div className="accordion-body border-top">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Street Address{" "}
                          </label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">City </label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            State / Province{" "}
                          </label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3 mb-md-0">
                          <label className="col-form-label">Country</label>
                          <Select
                            className="select2"
                            classNamePrefix="react-select"
                            options={countries}
                            placeholder="Choose"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-0">
                          <label className="col-form-label">Zipcode </label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Address Info */}
              {/* Social Profile */}
              <div className="accordion-item border-top rounded mb-3">
                <div className="accordion-header">
                  <Link
                    to="#"
                    className="accordion-button accordion-custom-button rounded bg-white fw-medium text-dark"
                    data-bs-toggle="collapse"
                    data-bs-target="#social"
                  >
                    <span className="avatar avatar-md rounded text-dark border me-2">
                      <i className="ti ti-social fs-20" />
                    </span>
                    Social Profile
                  </Link>
                </div>
                <div
                  className="accordion-collapse collapse"
                  id="social"
                  data-bs-parent="#main_accordion"
                >
                  <div className="accordion-body border-top">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Facebook</label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Skype </label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Linkedin </label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Twitter</label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3 mb-md-0">
                          <label className="col-form-label">Whatsapp</label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-0">
                          <label className="col-form-label">Instagram</label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Social Profile */}
              {/* Access */}
              <div className="accordion-item border-top rounded mb-3">
                <div className="accordion-header">
                  <Link
                    to="#"
                    className="accordion-button accordion-custom-button rounded bg-white fw-medium text-dark"
                    data-bs-toggle="collapse"
                    data-bs-target="#access-info"
                  >
                    <span className="avatar avatar-md rounded text-dark border me-2">
                      <i className="ti ti-accessible fs-20" />
                    </span>
                    Access
                  </Link>
                </div>
                <div
                  className="accordion-collapse collapse"
                  id="access-info"
                  data-bs-parent="#main_accordion"
                >
                  <div className="accordion-body border-top">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="col-form-label">Visibility</label>
                          <div className="d-flex flex-wrap">
                            <div className="me-2">
                              <input
                                type="radio"
                                className="status-radio"
                                id="public"
                                name="visible"
                              />
                              <label htmlFor="public">Public</label>
                            </div>
                            <div className="me-2">
                              <input
                                type="radio"
                                className="status-radio"
                                id="private"
                                name="visible"
                              />
                              <label htmlFor="private">Private</label>
                            </div>
                            <div
                              data-bs-toggle="modal"
                              data-bs-target="#access_view"
                            >
                              <input
                                type="radio"
                                className="status-radio"
                                id="people"
                                name="visible"
                              />
                              <label htmlFor="people">Select People</label>
                            </div>
                          </div>
                        </div>
                        <div className="mb-0">
                          <label className="col-form-label">Status</label>
                          <div className="d-flex flex-wrap">
                            <div className="me-2">
                              <input
                                type="radio"
                                className="status-radio"
                                id="active"
                                name="status"
                                defaultChecked
                              />
                              <label htmlFor="active">Active</label>
                            </div>
                            <div>
                              <input
                                type="radio"
                                className="status-radio"
                                id="inactive"
                                name="status"
                              />
                              <label htmlFor="inactive">Inactive</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Access */}
            </div>
            <div className="d-flex align-items-center justify-content-end">
              <button
                type="button"
                data-bs-dismiss="offcanvas"
                className="btn btn-light me-2"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#create_success"
              >
                Create
              </button>
            </div>
          </form>
        </div>
      </div>
      {/* /Add Company */}
      {/* Add Task Modal */}
      <div className="modal custom-modal fade modal-padding" id="create_task" role="dialog">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Create Task</h5>
              <button type="button" className="btn-close position-static" data-bs-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="row">
                  <div className="col-md-12">
                    {/* Title */}
                    <div className="mb-3">
                      <label className="col-form-label">Title <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        className="form-control"
                        name="title"
                        value={newTaskData.title}
                        onChange={handleInputChange}
                      />
                    </div>

                    {/* Category */}
                    <div className="mb-3">
                      <label className="col-form-label">Category</label>
                      <Select
                        options={selectTaskCategoryOptions}
                        placeholder="Choose"
                        classNamePrefix="react-select"
                        value={newTaskData.category ? { label: newTaskData.category, value: newTaskData.category } : null}
                        onChange={(selectedOption) => setNewTaskData({ ...newTaskData, category: selectedOption?.value || "" })}
                      />
                    </div>

                    {/* Responsible */}
                    <div className="mb-3">
                      <label className="col-form-label">Responsible</label>
                      <select
                        className="form-control"
                        name="responsible"
                        value={newTaskData.responsible}
                        onChange={handleInputChange}
                      >
                        <option value="" disabled>Select Responsible</option>
                        {listUserCall.map((user) => (
                          <option key={user.uuid} value={user.uuid}>
                            {user.username}
                          </option>
                        ))}
                      </select>
                    </div>
                    {/* Assign Type */}
                    <div className="row">
                      {/* Assign Type */}
                      <div className="col-md-6">
                        <label className="col-form-label">Assign Type</label>
                        <select
                          className="form-control"
                          value={newTaskData.assignType}
                          disabled={true}
                          onChange={handleTaskAssignTypeChange}>

                          <option value="">Select Assign Type</option>
                          {selectAssignType.map((option) => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </div>

                      {/* Assign */}
                      <div className="col-md-6">
                        <label className="col-form-label">Assign</label>
                        <Select
                          className="select2"
                          options={assignTaskOptions}
                          placeholder="Choose"
                          classNamePrefix="react-select"
                          value={assignTaskOptions.find(option => option.value === newTaskData.assignId) || null}
                          onChange={(selectedOption) => setNewTaskData({ ...newTaskData, assignId: selectedOption?.value || 0 })}
                          isDisabled={true}
                        />
                      </div>
                    </div>

                    {/* Target Type */}
                    <div className="row">
                      <div className="col-md-6">
                        <label className="col-form-label">Target Type</label>
                        <select
                          className="form-control"
                          value={newTaskData.targetType}
                          onChange={handleTaskRelatedToTypeChange}
                        >
                          <option value="">Select Target Type</option>
                          {selectRelatedToType.map((option) => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </div>

                      {/* Target */}
                      <div className="col-md-6">
                        <label className="col-form-label">Target</label>
                        <Select
                          className="select2"
                          options={relateTaskOptions}
                          placeholder="Choose"
                          classNamePrefix="react-select"
                          value={relateTaskOptions.find(option => option.value === newTaskData.targetId) || null}
                          onChange={(selectedOption) => setNewTaskData({ ...newTaskData, targetId: selectedOption?.value || 0 })}
                          isDisabled={relateTaskOptions.length === 0}
                        />
                      </div>
                    </div>


                    <div className="row">
                      {/* Start Date */}
                      <div className="mb-6">
                        <label className="col-form-label">Start Date <span className="text-danger">*</span></label>
                        <input
                          type="datetime-local"
                          className="form-control"
                          name="startDate"
                          value={newTaskData.startDate}
                          onChange={handleInputChange}
                        />
                      </div>

                      {/* End Date */}
                      <div className="mb-6">
                        <label className="col-form-label">End Date</label>
                        <input
                          type="datetime-local"
                          className="form-control"
                          name="endDate"
                          value={newTaskData.endDate}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>

                    {/* Status */}
                    <div className="mb-3">
                      <label className="col-form-label">Status <span className="text-danger">*</span></label>
                      <Select
                        options={selectTaskStatusOptions}
                        placeholder="Choose"
                        classNamePrefix="react-select"
                        value={newTaskData.status ? { label: newTaskData.status, value: newTaskData.status } : null}
                        onChange={(selectedOption) => setNewTaskData({ ...newTaskData, status: selectedOption?.value || "" })}
                      />
                    </div>

                    {/* Priority */}
                    <div className="mb-3">
                      <label className="col-form-label">Priority</label>
                      <Select
                        options={selectTaskPriorityOptions}
                        placeholder="Choose"
                        classNamePrefix="react-select"
                        value={newTaskData.priority ? { label: newTaskData.priority, value: newTaskData.priority } : null}
                        onChange={(selectedOption) => setNewTaskData({ ...newTaskData, priority: selectedOption?.value || "" })}
                      />
                    </div>

                    {/* Description */}
                    <div className="mb-3">
                      <label className="col-form-label">Description</label>
                      <textarea
                        className="form-control"
                        name="description"
                        rows={4}
                        value={newTaskData.description}
                        onChange={handleInputChange}
                      />
                    </div>

                    {/* Confirm & Cancel Buttons */}
                    <div className="text-end modal-btn">
                      <button className="btn btn-light" data-bs-dismiss="modal">Cancel</button>
                      <button className="btn btn-primary" data-bs-dismiss="modal" type="button" onClick={handleCreateTasks}>
                        Confirm
                      </button>
                    </div>

                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/*Update Task*/}
      <div className="modal custom-modal fade modal-padding" id="edit_task" role="dialog">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Update Task</h5>
              <button type="button" className="btn-close position-static" data-bs-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="row">
                  <div className="col-md-12">
                    {/* Title */}
                    <div className="mb-3">
                      <label className="col-form-label">Title <span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name="title" value={editingTask?.title || ""} onChange={handleUpdateTaskInputChange} />
                    </div>

                    {/* Category */}
                    <div className="mb-3">
                      <label className="col-form-label">Category</label>
                      <Select
                        options={selectTaskCategoryOptions}
                        placeholder="Choose"
                        name="category"
                        value={selectTaskCategoryOptions.find(opt => opt.value === editingTask?.category)}
                        onChange={(option) => handleUpdateTaskSelectChange("category", option?.value ?? "")}
                        classNamePrefix="react-select"
                      />
                    </div>

                    {/* Responsible */}
                    <div className="mb-3">
                      <label className="col-form-label">Responsible</label>
                      <select className="form-control" name="responsible" disabled={true} value={editingTask?.responsible.uuid || ""} onChange={handleUpdateTaskInputChange}>
                        <option value="" disabled>Select Responsible</option>
                        {listUserCall.map(user => (
                          <option key={user.uuid} value={user.uuid}>{user.username}</option>
                        ))}
                      </select>
                    </div>
                    {/* Assign Type */}
                    <div className="row">
                      <div className="col-md-6">
                        <label className="col-form-label">Assign Type</label>
                        <select className="form-control" name="assignType" disabled={true} value={selectAssignType.find(option => option.value === editingTask?.assignType)?.value || "LEAD"} onChange={handleUpdateTaskInputChange}>
                          <option value="">Select Assign Type</option>
                          {selectAssignType.map(option => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </div>

                      {/* Assign */}
                      <div className="col-md-6">
                        <label className="col-form-label">Assign</label>
                        <Select
                          options={assignTaskOptions}
                          placeholder="Choose"
                          value={assignTaskOptions.find(opt => opt.value === editingTask?.assignee?.id) || null}
                          onChange={(option) => handleUpdateTaskSelectChange("assignId", option?.value || 0)}
                          isDisabled={true}
                          classNamePrefix="react-select"
                        />
                      </div>
                    </div>

                    {/* Target Type */}
                    <div className="row">
                      <div className="col-md-6">
                        <label className="col-form-label">Target Type</label>
                        <select className="form-control" name="targetType" value={editingTask?.targetType || ""} onChange={handleUpdateTaskInputChange}>
                          <option value="">Select Target Type</option>
                          {selectRelatedToType.map(option => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </div>

                      {/* Target ID */}
                      <div className="col-md-6">
                        <label className="col-form-label">Target</label>
                        <Select
                          options={relateTaskOptions}
                          placeholder="Choose"
                          value={relateTaskOptions.find(opt => opt.value === editingTask?.targets?.id) || null}
                          onChange={(option) => handleUpdateTaskSelectChange("targetId", option?.value ?? 0)}
                          isDisabled={relateTaskOptions.length === 0}
                          classNamePrefix="react-select"
                        />
                      </div>
                    </div>

                    <div className="row">
                      {/* Start Date */}
                      <div className="mb-6">
                        <label className="col-form-label">Start Date <span className="text-danger">*</span></label>
                        <input type="datetime-local" className="form-control" name="startDate" value={editingTask?.startDate || ""} onChange={handleUpdateTaskInputChange} />
                      </div>

                      {/* End Date */}
                      <div className="mb-6">
                        <label className="col-form-label">End Date</label>
                        <input type="datetime-local" className="form-control" name="endDate" value={editingTask?.endDate || ""} onChange={handleUpdateTaskInputChange} />
                      </div>
                    </div>

                    {/* Status */}
                    <div className="mb-3">
                      <label className="col-form-label">Status <span className="text-danger">*</span></label>
                      <Select options={selectTaskStatusOptions}
                        value={selectTaskStatusOptions.find(opt => opt.value === editingTask?.status)}
                        onChange={(option) => handleUpdateTaskSelectChange("status", option?.value || "")} />
                    </div>

                    {/* Priority */}
                    <div className="mb-3">
                      <label className="col-form-label">Priority</label>
                      <Select options={selectTaskPriorityOptions} placeholder="Choose"
                        value={selectTaskPriorityOptions.find(opt => opt.value === editingTask?.priority)}
                        onChange={(option) => handleUpdateTaskSelectChange("priority", option?.value || "")} classNamePrefix="react-select" />
                    </div>

                    {/* Description */}
                    <div className="mb-3">
                      <label className="col-form-label">Description</label>
                      <textarea className="form-control" rows={4} name="description" value={editingTask?.description || ""} onChange={handleUpdateTaskInputChange} />
                    </div>

                    {/* Confirm & Cancel Buttons */}
                    <div className="text-end modal-btn">
                      <button className="btn btn-light" data-bs-dismiss="modal">Cancel</button>
                      <button
                        className="btn btn-primary"
                        data-bs-dismiss="modal"
                        type="button"
                        onClick={() => selectedTaskId?.id && handleUpdateTask(selectedTaskId?.id)}
                      >
                        Confirm
                      </button>
                    </div>

                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/*Update Task*/}
      {/* Add Event */}
      <div
        className="modal custom-modal fade modal-padding"
        id="create_event"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add New Event</h5>
              <button
                type="button"
                className="btn-close position-static"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Subject <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter subject"
                        value={newEventData.subject}
                        onChange={(e) => setNewEventData({ ...newEventData, subject: e.target.value })}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="col-form-label">Description</label>
                      <textarea
                        className="form-control"
                        rows={4}
                        placeholder="Enter description"
                        value={newEventData.description}
                        onChange={(e) => setNewEventData({ ...newEventData, description: e.target.value })}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="col-form-label">Location</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter location"
                        value={newEventData.location}
                        onChange={(e) => setNewEventData({ ...newEventData, location: e.target.value })}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="col-form-label">Attendees</label>
                      <Select
                        isMulti
                        options={attendeesOptions}
                        value={attendees}
                        onChange={handleSelectAttendeesChange}
                        classNamePrefix="react-select"
                        styles={{
                          control: (provided, state) => ({
                            ...provided,
                            minHeight: "50px",
                            maxHeight: "none",
                            flexWrap: "wrap",
                            overflowY: "auto",
                          }),
                          valueContainer: (provided) => ({
                            ...provided,
                            flexWrap: "wrap",
                            maxHeight: "150px",
                            overflowY: "auto",
                          }),
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 9999,
                          }),
                        }}
                      />
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <label className="col-form-label">Assign Type</label>
                        <select
                          className="form-control"
                          value={newEventData.assignType}
                          onChange={handleTaskAssignTypeChange}>
                          <option value="">Select Assign Type</option>
                          {selectAssignType.map((option) => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-6">
                        <label className="col-form-label">Assign</label>
                        <Select
                          isMulti
                          className="select2"
                          options={assignTaskOptions}
                          placeholder="Choose"
                          classNamePrefix="react-select"
                          value={assignTaskOptions.filter(option =>
                            newEventData.assigneeId && Array.isArray(newEventData.assigneeId)
                              ? newEventData.assigneeId.includes(option.value)
                              : false
                          )}
                          onChange={(selectedOptions: MultiValue<{ value: number; label: string }>) =>
                            setNewEventData({
                              ...newEventData,
                              assigneeId: selectedOptions.length > 0
                                ? selectedOptions.map((option) => option.value)
                                : [],
                            })
                          }
                          isDisabled={assignTaskOptions.length === 0}
                          styles={{
                            control: (provided, state) => ({
                              ...provided,
                              minHeight: "50px",
                              maxHeight: "none",
                              flexWrap: "wrap",
                              overflowY: "auto",
                            }),
                            valueContainer: (provided) => ({
                              ...provided,
                              flexWrap: "wrap",
                              maxHeight: "150px",
                              overflowY: "auto",
                            }),
                            menu: (provided) => ({
                              ...provided,
                              zIndex: 9999,
                            }),
                          }}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <label className="col-form-label">Target Type</label>
                        <select
                          className="form-control"
                          value={newEventData.targetType}
                          onChange={handleTaskRelatedToTypeChange}
                        >
                          <option value="">Select Target Type</option>
                          {selectRelatedToType.map((option) => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </div>
                      {/* Target */}
                      <div className="col-md-6">
                        <label className="col-form-label">Target</label>
                        <Select
                          className="select2"
                          options={relateTaskOptions}
                          placeholder="Choose"
                          classNamePrefix="react-select"
                          value={relateTaskOptions.find(option => option.value === newEventData.targetIds) || null}
                          onChange={(selectedOption) => setNewEventData({ ...newEventData, targetIds: selectedOption?.value || 0 })}
                          isDisabled={relateTaskOptions.length === 0}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <label className="col-form-label">Start Time</label>
                        <input
                          type="datetime-local"
                          className="form-control"
                          value={newEventData.startTime}
                          onChange={(e) => setNewEventData({ ...newEventData, startTime: e.target.value })}
                        />
                      </div>
                      <div className="col-md-12">
                        <label className="col-form-label">End Time</label>
                        <input
                          type="datetime-local"
                          className="form-control"
                          value={newEventData.endTime}
                          onChange={(e) => setNewEventData({ ...newEventData, endTime: e.target.value })}
                        />
                      </div>
                    </div>
                    <div className="text-end modal-btn mt-3">
                      <button
                        className="btn btn-light"
                        data-bs-dismiss="modal"
                        type="button"
                      >
                        Cancel
                      </button>
                      <button className="btn btn-primary" data-bs-dismiss="modal" type="button" onClick={handleCreateEvent}>
                        Create
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* /Add Event */}
      {/* /Update Event */}
      <div
        className="modal custom-modal fade modal-padding"
        id="edit_event"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Update Event</h5>
              <button
                type="button"
                className="btn-close position-static"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Subject <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter subject"
                        value={editEventData.subject}
                        onChange={(e) => setEditEventData({ ...editEventData, subject: e.target.value })}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="col-form-label">Description</label>
                      <textarea
                        className="form-control"
                        rows={4}
                        placeholder="Enter description"
                        value={editEventData.description}
                        onChange={(e) => setEditEventData({ ...editEventData, description: e.target.value })}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="col-form-label">Location</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter location"
                        value={editEventData.location}
                        onChange={(e) => setEditEventData({ ...editEventData, location: e.target.value })}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="col-form-label">Attendees</label>
                      <Select
                        isMulti
                        options={attendeesOptions}
                        value={selectedAttendees}
                        onChange={handleSelectAttendeesChange}
                        classNamePrefix="react-select"
                      />
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <label className="col-form-label">Assign Type</label>
                        <select
                          className="form-control"
                          value={editEventData.assignType}
                          onChange={handleTaskAssignTypeChange}>
                          <option value="">Select Assign Type</option>
                          {selectAssignType.map((option) => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-6">
                        <label className="col-form-label">Assign</label>
                        <Select
                          isMulti
                          className="select2"
                          options={assignTaskOptions}
                          placeholder="Choose"
                          classNamePrefix="react-select"
                          value={assignTaskOptions.filter(option => editEventData.assigneeId.includes(option.value))}
                          onChange={(selectedOptions: MultiValue<{ value: number; label: string }>) =>
                            setEditEventData({
                              ...editEventData,
                              assigneeId: selectedOptions.map((option) => option.value),
                            })
                          }
                          isDisabled={assignTaskOptions.length === 0}
                          styles={{
                            control: (provided, state) => ({
                              ...provided,
                              minHeight: "50px",
                              maxHeight: "auto",
                              overflowY: "auto",
                            }),
                            menu: (provided) => ({
                              ...provided,
                              zIndex: 9999,
                            }),
                          }}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <label className="col-form-label">Target Type</label>
                        <select
                          className="form-control"
                          value={editEventData?.targetType}
                          onChange={handleTaskRelatedToTypeChange}
                        >
                          <option value="">Select Target Type</option>
                          {selectRelatedToType.map((option) => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </div>
                      {/* Target */}
                      <div className="col-md-6">
                        <label className="col-form-label">Target</label>
                        <Select
                          className="select2"
                          options={relateTaskOptions}
                          placeholder="Choose"
                          classNamePrefix="react-select"
                          value={relateTaskOptions.find(option => option.value === editEventData.targetIds)}
                          onChange={(selectedOption) => setEditEventData({ ...editEventData, targetIds: selectedOption?.value || 0 })}
                          isDisabled={relateTaskOptions.length === 0}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <label className="col-form-label">Start Time</label>
                        <input
                          type="datetime-local"
                          className="form-control"
                          value={editEventData.startTime}
                          onChange={(e) => setEditEventData({ ...editEventData, startTime: e.target.value })}
                        />
                      </div>
                      <div className="col-md-12">
                        <label className="col-form-label">End Time</label>
                        <input
                          type="datetime-local"
                          className="form-control"
                          value={editEventData.endTime}
                          onChange={(e) => setEditEventData({ ...editEventData, endTime: e.target.value })}
                        />
                      </div>
                    </div>
                    <div className="text-end modal-btn mt-3">
                      <button
                        className="btn btn-light"
                        data-bs-dismiss="modal"
                        type="button"
                      >
                        Cancel
                      </button>
                      <button className="btn btn-primary" data-bs-dismiss="modal" type="button" onClick={handleUpdateEvent}>
                        Confirm
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Update Event */}
      {/* Log Call Modal */}
      <Modal show={showCallModal} onHide={() => setShowCallModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Log Call</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="mb-3">
              <label className="col-form-label">
                User <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                value={"53331378-8620-41dc-b008-b1966f583b0f"}
                onChange={(e) => setLogCallUserCall(e.target.value)}
                placeholder="Enter user name"
              />
            </div>
            <div className="mb-3">
              <label className="col-form-label">
                Status <span className="text-danger">*</span>
              </label>
              <Select
                className="select"
                options={[
                  { value: 'BUSY', label: 'Busy' },
                  { value: 'NO_ANSWER', label: 'No Answer' },
                  { value: 'UNAVAILABLE', label: 'Unavailable' },
                  { value: 'WRONG_NUMBER', label: 'Wrong Number' },
                  { value: 'LEFT_VOICE_MESSAGE', label: 'Left Voice Message' },
                  { value: 'MOVING_FORWARD', label: 'Moving Forward' }
                ]}
                onChange={handleLogCallStatusChange}
                placeholder="Select Status"
                classNamePrefix="react-select"
              />
            </div>
            <div className="mb-3">
              <label className="col-form-label">
                Follow-up Date
              </label>
              <input
                type="datetime-local"
                className="form-control"
                value={logCallFollowUpDate}
                onChange={handleFollowUpDateChange}
              />
            </div>
            <div className="mb-3">
              <label className="col-form-label">
                Notes
              </label>
              <textarea
                className="form-control"
                rows={4}
                value={logCallNote}
                onChange={handleNoteChange}
                placeholder="Enter call notes"
              ></textarea>
            </div>
            <div className="mb-3">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="createFollowingTask"
                  checked={createLogCallFollowingTask}
                  onChange={handleCreateFollowingTaskChange}
                />
                <label className="form-check-label" htmlFor="createFollowingTask">
                  Create following task
                </label>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={() => setShowCallModal(false)}>
            Cancel
          </button>
          <button className="btn btn-primary" onClick={handleCreateLogCall}>
            Create Call
          </button>
        </Modal.Footer>
      </Modal>
      {/* /Edit Call Log */}
      <div
        className="modal custom-modal fade modal-padding"
        id="edit_call"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit Call Log</h5>
              <button
                type="button"
                className="btn-close position-static"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="col-form-label">
                        User Call <span className="text-danger"> *</span>
                      </label>
                      {loading ? (
                        <div>Loading...</div>
                      ) : error ? (
                        <div className="text-danger">{error}</div>
                      ) : (
                        <select
                          className="form-control"
                          value={editLogCall?.userCall || ""}
                          disabled={true}
                          onChange={(e) => handleSelectChange(e, "userCall")}
                        >
                          <option value="" disabled>
                            Select User Call
                          </option>
                          {listUserCall.length > 0 ? (
                            listUserCall.map((user) => (
                              <option key={user.uuid} value={user.uuid}>
                                {user.username}
                              </option>
                            ))
                          ) : (
                            <option value="">No users available</option>
                          )}
                        </select>
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="col-form-label">
                        Status <span className="text-danger"> *</span>
                      </label>
                      <Select
                        className="select2"
                        options={statusList}
                        placeholder="Choose"
                        classNamePrefix="react-select"
                        name="status"
                        value={statusList.find((status) => status.value === editLogCall?.status)}
                        onChange={(selectedOption) => handleSelectChange(selectedOption, "status")}
                      />
                    </div>

                    <div className="mb-3">
                      <label className="col-form-label">
                        Follow Up Date <span className="text-danger"> *</span>
                      </label>
                      <div className="icon-form">
                        <span className="form-icon">
                          <i className="ti ti-calendar-check" />
                        </span>
                        <input
                          type="datetime-local"
                          className="form-control"
                          name="followUpDate"
                          value={editLogCall?.followUpDate}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <label className="col-form-label">Assign Type</label>
                        <select className="form-control" name="assignType" disabled={true} value={selectAssignType.find(option => option.value === editLogCall?.assignType)?.value || "LEAD"} onChange={handleUpdateTaskInputChange}>
                          <option value="">Select Assign Type</option>
                          {selectAssignType.map(option => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </div>

                      {/* Assign */}
                      <div className="col-md-6">
                        <label className="col-form-label">Assign</label>
                        <Select
                          options={assignTaskOptions}
                          placeholder="Choose"
                          value={assignTaskOptions.find(opt => opt.value === editLogCall?.assignRecord) || null}
                          onChange={(option) => handleUpdateTaskSelectChange("assignRecord", option?.value || 0)}
                          isDisabled={true}
                          classNamePrefix="react-select"
                        />
                      </div>
                    </div>

                    {/* Target Type */}
                    <div className="row">
                      <div className="col-md-6">
                        <label className="col-form-label">Target Type</label>
                        <select className="form-control" name="targetType" value={editLogCall?.targetType || ""} onChange={handleUpdateTaskInputChange}>
                          <option value="">Select Target Type</option>
                          {selectRelatedToType.map(option => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </div>

                      {/* Target ID */}
                      <div className="col-md-6">
                        <label className="col-form-label">Target</label>
                        <Select
                          options={relateTaskOptions}
                          placeholder="Choose"
                          value={relateTaskOptions.find(opt => opt.value === editLogCall?.targetRecord) || null}
                          onChange={(option) => handleUpdateTaskSelectChange("targetRecord", option?.value ?? 0)}
                          isDisabled={relateTaskOptions.length === 0}
                          classNamePrefix="react-select"
                        />
                      </div>
                    </div>
                    <div className="mb-3">
                      <label className="col-form-label">
                        Note <span className="text-danger"> *</span>
                      </label>
                      <textarea
                        className="form-control"
                        rows={4}
                        placeholder="Add text"
                        name="note"
                        value={editLogCall?.note || ""}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className="text-end modal-btn">
                      <Link
                        to="#"
                        className="btn btn-light"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </Link>
                      <button
                        className="btn btn-primary"
                        data-bs-dismiss="modal"
                        type="button"
                        onClick={() => selectedLogCallId?.id && handleUpdateLogCall(selectedLogCallId?.id)}
                      >
                        Confirm
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Modal show={showEmailModal} onHide={() => setShowEmailModal(false)} backdrop="static" size="lg">
        <div className="modal-header border-bottom">
          <h5 className="modal-title">Send Email</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setShowEmailModal(false)}
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="modal-body">
          <form>
            <div className="row">
              <div className="col-md-12 mb-3">
                <label className="form-label">From Email</label>
                <input
                  type="email"
                  className="form-control"
                  name="fromEmail"
                  value={emailData.fromEmail}
                  readOnly
                />
              </div>
              <div className="col-md-12 mb-3">
                <label className="form-label">To</label>
                <input
                  type="email"
                  className="form-control"
                  value={emailData.contactEmail}
                  readOnly
                />
              </div>
              <div className="col-md-12 mb-3">
                <label className="form-label">Subject</label>
                <input
                  type="text"
                  className="form-control"
                  name="subject"
                  value={emailData.subject}
                  onChange={handleEmailChange}
                  required
                />
              </div>
              <div className="col-md-12 mb-3">
                <label className="form-label">Message</label>
                <DefaultEditor
                  className="summernote"
                  style={{ height: "400px" }}
                  value={emailData.body}
                  onChange={(event) => {
                    setEmailData(prev => ({
                      ...prev,
                      body: event.target.value
                    }));
                  }}
                />
              </div>
            </div>
          </form>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-light"
            onClick={() => setShowEmailModal(false)}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleSendEmail}
            disabled={!emailData.fromEmail || !emailData.subject || !emailData.body}
          >
            Send Email
          </button>
        </div>
      </Modal>

      {/* Delete Call Modal */}
      <Modal show={showDeleteCallModal} onHide={() => setShowDeleteCallModal(false)} centered>
        <Modal.Body className="text-center">
          <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
            <i className="ti ti-trash-x fs-36 text-danger" />
          </div>
          <h4 className="mb-2">Delete Call Log?</h4>
          <p className="mb-0">
            Are you sure you want to delete this call log?
            This action cannot be undone.
          </p>
        </Modal.Body>
        <Modal.Footer className="justify-content-center border-0">
          <button className="btn btn-light me-2" onClick={() => setShowDeleteCallModal(false)}>
            Cancel
          </button>
          <button className="btn btn-danger" onClick={handleConfirmDeleteCall}>
            Yes, Delete
          </button>
        </Modal.Footer>
      </Modal>
      <ResponseModal show={showMessageModal} onClose={() => setShowMessageModal(false)} response={response} />
    </>
  );
};

export default ContactDetails;
